import { create } from "domain";

export default {
    salesforceNavigation: {
        openContractAssets: "Open the owning contract's Assets in Salesforce",
        assetsLabel: "SF Assets",
        openAccount: "Open account in Salesforce",
        openContract: "Open contract in Salesforce",
        loading: "Loading Salesforce link",
        popupBlocked: "Your browser blocked the tab. Allow pop-ups and try again.",
        NotLinked: "No matching record found in Salesforce",
        Ambiguous: "Multiple Salesforce records match; link unavailable",
        Unavailable: "Salesforce link unavailable",
    },
    supportOrders: {
        executionFailed: "Execution failed",
        awaitingManualExecution: "Awaiting manual execution",
        awaitingExecution: "Awaiting execution",
        waitingForAgreement: "Waiting for support agreement",
        followUpTitle: "Salesforce orders requiring follow-up",
    },
    licenseUsageSummary: {
        daysUsed: "Days used",
        userDays: "User-days",
        failures: "Failures",
        userDetails: "User details",
        productsTab: "Products",
        graphTab: "Chart",
        productsTitle: "Usage by product",
        productDetails: "Product details",
        productUsageInfo: "Product totals use the included online licenses. Unique users are deduplicated; user-days remain summed per user and license. Unassigned failures are included independently of the inactive-license toggle. Peak occupancy and recorded capacity ranges are shown directly when exactly one license is included.",
        seeLicenseDetails: "See license details",
        multipleLicensePeaksInfo: "Some products have multiple included licenses. Their peak occupancy and recorded capacity range cannot safely be combined; expand the product to see these values per license.",
        productUnassignedFailuresInfo: "These failures are included in the product total, but cannot be assigned unambiguously to a license.",
        noProductLicenses: "No licenses are included for this product with the current filters.",
        noUnassignedProductFailures: "No unassigned failures are recorded for this product in the selected period.",
        usageTab: "Usage",
        rejectionsTab: "Failures ({{count}})",
        noLicenseTab: "No license available ({{count}})",
        userUnassignedFailuresInfo: "These failures are included in this user's total, but cannot be assigned unambiguously to a license. Grouped by product.",
        noUnassignedUserFailures: "No unassigned failures are recorded for this user in the selected period.",
        noUserLicenses: "No license usage or license-attributed failures are shown for this user with the current filters.",
        allSeatsOccupied: "Failures: all seats occupied",
        noLicenseAvailable: "Failures: no license available",
        productCode: "Product code",
        attribution: "License attribution",
        NoMatchingLicense: "License not found in the selected inventory",
        NoLicenseReference: "No license reference recorded",
        AmbiguousLicense: "Multiple licenses match the recorded license number and product code",
        ProductMismatch: "Missing or conflicting product code",
        unassignedFailures: "Failures not assigned to a license",
        unassignedFailuresInfo: "Failures are grouped by product. Expand a product to see the recorded users and customers. Counts are included on user rows, but never assigned to a license or counted as usage. These events are not affected by the inactive-license toggle.",
        daysAndFailuresInfo: "A user-day is one user using one license on one recorded UTC date. Repeated sessions that day count once; license and user totals sum user-license days. Only all-seats-occupied and no-license-available events are counted as failures. Failure-only users have zero usage. These figures reflect recorded history, not an Autodesk billing reconciliation.",
        title: "License usage",
        usersTitle: "Usage by user",
        perspective: "Report perspective",
        reportInfo: "About this report",
        reportInfoWithWarnings: "About this report: incomplete usage data",
        licensesTab: "Licenses",
        usersTab: "Users",
        licensesUsed: "Licenses used",
        userHours: "User hours in use",
        noRecordedUsers: "No user activity is recorded for the licenses matching the selected filters and period.",
        currentSeats: "Seats today",
        recordedSeats: "Recorded seats",
        unknown: "Unknown",
        showInactive: "Show inactive licenses",
        terminationDate: "Termination date",
        peakOccupiedSeats: "Max concurrent users",
        uniqueUsers: "Unique users",
        hours: "Hours in use",
        empty: "No licensing-enabled licenses match the selected filters.",
        noUsers: "No user activity is recorded for this license in the selected period.",
        historicalModuleUsageInfo: "When a module has no start timestamp, the main session's start is used as an estimate. This may overstate hours in use, max concurrent users and user-days. Historical module data may also reflect the full main session rather than the module's actual usage interval. Estimated usage counts as usage, not excluded seat-days.",
        excludedSeatDays: "Excluded seat-days",
        incompleteSeatCoverage: "Incomplete usage data for licenses {{licenses}}: Seats without a valid start time are excluded. Hours, seat peaks and user counts may be understated, and zero does not necessarily mean no usage. Excluded seat-days count each affected seat once per day.",
    },
    "app": {
        "customers": "Customers",
        "customerDetails": "Customer Details",
        "contracts": "Contracts",
        "userSupport": "User Support",
        "productList": "Product List",
        "licenses": "Licenses",
        "activeUsers": "Active Users",
        "loginFailed": "Login Failed",
        "rejectedLogin": "Rejected Login",
        "licenseExploitation": "License Exploitation",
        "personActivity": "Person Activity",
        "expiredLicenses": "Expired Licenses",
        licenseChanges: "License Changes",
        "offlineLicenses": "Offline Licenses",
        "system": "System",
        "webUpdates": "Web Updates",
        "reports": "Reports",
        "newSales": "New Sales",
        "renewals": "Renewals",
        "churn": "Churn",
        "graphs": "Graphs",
        "licenseUsage": "License Usage",
        "sale": "Sale",
        "other": "Other",
        "productStructure": "Product Structure",
        "productVersion": "Product Version",
        "course": "Course",
        "checkFocusAccount": "Check Focus Account",
        "emails": "Emails",
        "offers": "Offers",
        "kuaAdmin": "Kua Admin",
        "company": "Company",
        "futureRenewals": "Future Renewals",
        "requests": "Requests",
        "myPageStatus": "My Page Status",
        "secretPages": "Secret Pages",
        "courseAdmin": "Course Admin",
        "courseCatalog": "Course Catalog",
        "courseList": "Course List",
        "courseEvaluation": "Course Evaluation",
        "resources": "Resources",
        "informationTexts": "Information Texts",
        "emailTemplates": "Email Templates",
        users: "Users",
        "autodeskOpportunities": "Opportunities",
        licenseAccess: "License Access",
        "failedOrders": "SF Failed Orders",
        assetSync: "SF License sync",
        accountReconciliation: "SF reconciliation"
    },
    salesForceAccountReconciliation: {
        sync: {
            column: "Action", button: "Sync SF → WK", warningButton: "Sync SF → WK (warning)",
            savedButton: "Order recorded", title: "Sync account {{number}} from SF to WK",
            tooltip: "Will sync from SF to WK: {{fields}}.",
            blockedLink: "Cannot sync: the customer link is incomplete.",
            description: "SF is the source for compared fields, including empty values. Visiting city maps to WK Place; BillingCity maps to postal city. Payer code and address extras are preserved.",
            billingCityWarning: "Check the SF visiting city before syncing: BillingCity ({{city}}) matches WK, but the visiting city differs or is empty. Sync uses visiting city, not BillingCity.",
            clearWarning: "Warning: Missing SF values will remove existing WK values in these fields.",
            blocked: "Sync requires a unique customer in both systems and known fields/country codes.",
            preview: "Fresh field differences before sync", loading: "Checking or submitting the order …",
            confirm: "Confirm and submit order", close: "Close", newPreview: "Fetch a new preview",
            retry: "Check the same submission", refresh: "Recheck the report",
            submitted: "The order was submitted. This does not confirm synchronization is complete. Check order status and refetch the report after execution.",
            recorded: "This order is already saved and was not resubmitted. Check order status; execution is not confirmed here.",
            orderId: "Order ID: {{id}}",
            errors: {
                InvalidPreview: "The confirmation has expired or is invalid. Fetch a new preview.",
                SourceChanged: "SF or WK data changed since the preview. Check fresh values before syncing.",
                AmbiguousLink: "The customer mapping is no longer unique. Check customer number, source IDs and duplicates.",
                NoLongerEligible: "The SF Account no longer has a Contract. Sync is blocked.",
                NoDifferences: "There are no differences to sync now. Refetch the report.",
                SellerUnresolved: "The SF seller email cannot be matched uniquely to a WK user. Sync is blocked.",
                UnknownCountry: "The SF country code is not recognized. Sync is blocked.",
                OperatorUnresolved: "The signed-in operator cannot be matched uniquely to a WK user.",
                PendingOrder: "An Account update order is already open. Check it before another sync.",
                OrderConflict: "An existing order could not be safely linked to this action. Check the order.",
                DispatchFailed: "The order was saved, but orchestrator dispatch was not confirmed. Check the order before another sync.",
                IncompleteSource: "The SF response omitted selected fields. Sync is blocked to prevent unintended clearing.",
                RequestFailed: "The request could not be confirmed. For submissions, the order may already be saved. Check the same submission or order status before another sync."
            }
        },
        contractScope: "SF Accounts without Contracts are not compared. Excluded from the fetched selection: {{excluded}}. All Contract statuses qualify.",
        contractScopeCountUnavailable: "Contract scope was applied, but the excluded SF Account count is missing or invalid. Refetch the report.",
        salesforceAccount: "SF customer", webkuaAccount: "WK customer",
        salesforceName: "SF customer name", webkuaName: "WK customer name",
        mainFinding: "Main finding", allFindings: "All findings", differences: "Field differences (raw values)",
        canSyncFilter: "Can sync ({{count}})",
        differencesTitle: "What differs", nextCheck: "What to check",
        moreFindings_one: "1 other finding", moreFindings_other: "{{count}} other findings",
        notFound: "Not found", notCompared: "Not compared",
        notReported: "Not provided", emptyValue: "Empty value",
        sourceLimitations: "The report contains customer names and differing fields, not complete customer documents. Equal fields are not shown.",
        missingSalesforceKey: "The SF customer has no WebKUA customer number. The link cannot be checked.",
        missingWebkuaKey: "The WK customer has no customer number. The link cannot be checked.",
        notFoundInWebkua: "The SF customer was not found in WK.",
        notFoundInSalesforce: "The WK customer was not found in SF.",
        ambiguousCustomer: "The customer number belongs to multiple customers. The link is ambiguous.",
        unknownComparisonField: "Unknown comparison field.",
        fieldMismatch: "{{field}} differs.", missingField: "{{field}} is not provided in {{system}}.",
        unrecognizedCountry: "The SF country code is not recognized.",
        unknownField: "Unknown comparison field: {{field}}",
        noFindingDetails: "No specific field differences provided. Check the source data.",
        filteredRows: "Showing {{shown}} of {{total}} rows.", clearFilters: "Clear finding filters",
        filters: { linkage: "Customer linkage", fields: "Field differences", identity: "Customer identity",
            contact: "Seller contact", address: "Address", unresolved: "Unresolved sources" },
        fields: { companyName: "Customer name", organizationNumber: "Organization number",
            sellerEmail: "Seller email", csn: "Autodesk customer number (CSN)", visitingCity: "Visiting city (SF / WK Place)",
            postalAddress: "Postal address", postalCity: "Postal city", postalCode: "Postal code",
            country: "Country (SF code / WK country ID)", countryUnrecognized: "Country code (not recognized in SF)" },
        checks: {
            linkage: "Check customer numbers and duplicates before linking customers or correcting field values.",
            identity: "Check the customer's name and organization number against registered customer information.",
            csn: "Check both Autodesk customer numbers against the correct customer account.",
            contact: "Check the Account owner's email in SF against the seller contact in WK.",
            visitingCity: "Check SF visiting city (VisitingAddress__City__s) against WK Place. BillingCity is only used for postal city.",
            address: "Check the customer's postal address on both sides.",
            country: "SF uses ISO country codes, WK uses numeric country IDs. Check that the codes represent the correct country, not that raw values match.",
            unknownField: "This field is not mapped in the display. Check raw values and field mapping before correction.",
        },
        accounts: "Accounts",
        assets: "Assets",
        contracts: "Contracts",
        contractLoadError: "Could not fetch the contract comparison.",
        fetch: "Fetch selected comparisons",
        results: "Comparison results",
        assetLoadError: "Could not load the Asset comparison. No complete result list is available.",
        loading: "Loading comparison",
        loadError: "Could not load the account comparison. No complete result list is available.",
        incomplete: "The comparison is incomplete. This list may not contain every difference.",
        deferredAccountFields: "StarterMap payer code, additional address fields and account fields set only on creation have not yet been compared.",
        noDifferences: "No differences found.",
        salesforceId: "Salesforce ID",
        webkuaId: "WebKUA ID",
        status: "Status",
        field: "Field",
        salesforceValue: "Salesforce value",
        webkuaValue: "WebKUA value",
        UnmatchedSalesforce: "No WebKUA customer number in Salesforce",
        MissingInWebkua: "Missing in WebKUA",
        MissingInSalesforce: "Missing in Salesforce",
        DuplicateCompanyNumber: "Duplicate customer number - ambiguous match",
        FieldMismatch: "Field values differ",
    },
    salesForceContractReconciliation: {
        sync: {
            column: "Action", button: "Sync SF → WK", savedButton: "Order recorded",
            title: "Sync Contract {{number}} from SF to WK",
            tooltip: "Will sync from SF to WK: {{fields}}.",
            unsupportedFields: "Cannot sync: {{fields}} are not supported.",
            emptyFields: "Cannot sync: {{fields}} are missing in SF and cannot be cleared in WK.",
            inactiveSource: "Cannot sync: the Contract is not active in {{system}}.",
            todayEndDate: "Cannot sync: the end date is today and would change activity in WK.",
            linkNumber: "Cannot sync: the Contract number link is missing or different.",
            customerLink: "Cannot sync: the customer link is missing or the customers differ.",
            sourceLink: "Cannot sync: a source link is missing.",
            unsupportedKind: "Cannot sync: {{kind}}.",
            description: "This action submits the existing Contract update order with the displayed SF values. Other fields are preserved. The Contract is checked before submission, but the order can create a Contract if the WK link disappears before execution.",
            preview: "Fresh field differences before sync", loading: "Checking or submitting order …",
            confirm: "Confirm and submit order", close: "Close", newPreview: "Fetch a new preview",
            retry: "Check the same submission", refresh: "Recheck report",
            submitted: "The order was submitted. Synchronization is not confirmed complete. Check order status and reload the report after execution.",
            recorded: "The order is already saved and was not resent. Check order status; execution is not confirmed here.",
            orderId: "Order ID: {{id}}",
            errors: {
                InvalidPreview: "The confirmation has expired or is invalid. Fetch a new preview.",
                SourceChanged: "SF or WK data changed after the preview. Fetch a new preview.",
                AmbiguousLink: "Sync requires one Contract in each system, the same customer and unambiguous Contract numbers and source IDs.",
                NoDifferences: "No field differences can be corrected by this action. Date/status warnings alone cannot be synced.",
                UnsupportedDifference: "The existing order cannot correct every difference. Start date, invoice interval, invoice customer and activity changes are unsupported. An end date of today also cannot be synced without changing activity.",
                UnsafeSource: "Source data is incomplete, or SF status and dates are inconsistent. Check the details before syncing.",
                EmptySource: "The order cannot clear WK fields. Missing SF values therefore prevent syncing this row.",
                OperatorUnresolved: "The signed-in user cannot be uniquely matched to a WK user.",
                PendingOrder: "A Contract update order is already open. Check it before another sync.",
                OrderConflict: "An existing order could not be safely matched to this action. Check the order.",
                DispatchFailed: "The order was saved, but dispatch was not confirmed. Check the order before another sync.",
                RequestFailed: "The request could not be confirmed. The order may already be saved. Check the same submission or order status before another sync."
            }
        },
        sourcePresence: "Found in", mainFinding: "Main finding", allFindings: "All findings",
        comparisonKind: "Difference type", sfLinkKey: "SF link number stored in WK",
        presence: { both: "SF and WK", salesforceOnly: "SF only", webkuaOnly: "WK only", neither: "No sources" },
        multipleMatches: "Multiple possible matches", sourceEvidence: "Show source information",
        nextCheck: "What to check", moreFindings_one: "1 other finding", moreFindings_other: "{{count}} other findings",
        notFound: "Not found", notCompared: "Not compared", notReported: "Not provided",
        noTerminationDate: "No termination date", unknown: "Unresolved",
        noFindingDetails: "No specific reason provided. Check the source information.",
        missingLinkKey: "SF contract number is missing. The link cannot be checked.",
        notFoundInSalesforce: "The WK contract was not found in SF using this link number.",
        notFoundInWebkua: "The SF contract was not found in WK using this contract number.",
        ambiguousSources: "Multiple possible contract matches: {{sf}} in SF and {{wk}} in WK.",
        sourceIssue: "{{system}}: {{issue}}", unattributedIssue: "Source side not provided: {{issue}}",
        activityFinding: "SF: {{sf}} · WK: {{wk}}", customerFinding: "Different customer: SF {{sf}} · WK {{wk}}",
        fieldFinding: "{{field}} differs.",
        laggingWebkua_one: "WK is one invoice period behind SF.",
        laggingWebkua_other: "WK is {{count}} invoice periods behind SF.",
        laggingSalesforce_one: "SF is one invoice period behind WK.",
        laggingSalesforce_other: "SF is {{count}} invoice periods behind WK.",
        filteredRows: "Showing {{shown}} of {{total}} rows.", clearFilters: "Clear finding filters",
        filters: { linkage: "Contract linkage", activity: "Active status", renewal: "Renewal",
            fields: "Other contract fields", unresolved: "Unresolved sources", warningsOnly: "Warnings only" },
        findingRules: "Found in reflects sources actually fetched. An SF link number stored in WK does not prove an SF contract exists. A missing link number means the other side was not compared. Findings can overlap; multiple selected finding filters require all to match. Next checks are guidance, not a decision about which side is correct. SF scope includes Accounts with a WebKUA customer number.",
        checks: {
            customerLink: "Check SF contract number, customer and the WK link before correcting field values.",
            activity: "Check SF status and EndDate against WK termination and maintenance stop.",
            renewal: "Check renewal history and invoice intervals on both sides before correcting dates.",
            dates: "Check dates against the agreed contract period before correction.",
            billing: "Check invoice customer and billing information in SF and WK.",
            interval: "Check the invoice interval against the agreement.",
            contact: "Check Bill-to Contact in SF and contract responsible in WK.",
            sourceData: "Resolve missing or invalid information in the identified source before correction.",
        },
        contract: "Contract", company: "Customer", sfContract: "SF contract", wkContract: "WK contract",
        status: "Difference", changedFields: "Different fields", field: "Field", sfValue: "SF value", wkValue: "WK value",
        issuesTitle: "Unresolved sources", differences: "Field differences", noSource: "No linked contract.",
        current: "Active", ended: "Inactive",
        counts: "{{inSync}} of {{compared}} reliably compared contracts are in sync.",
        noDifferences: "No contract differences found within the comparison scope.",
        about: "About the contract comparison",
        scope: "Contracts current on at least one side, with unresolved activity or inconsistent SF status are included. Other ended contracts are omitted. Exact SF contract numbers link records even when their customers differ.",
        dateRules: "Only SF status Activated can be active; other nonempty statuses are inactive and missing status is unresolved. Dates are compared without time. SF EndDate is the last valid day. WK uses termination and maintenance stop; an activity difference on the termination day may therefore be expected.",
        renewalRules: "SF NextRenewDate__c is compared to WK NextInvoicingDate. For an unambiguous active contract pair on the same customer with matching valid invoice intervals, the earlier date is labelled not renewed when the gap is an exact whole-number multiple of the interval in calendar months. Other gaps are different renewal dates. This is a date-based assessment, not confirmation of successful or failed renewal. Every date before the comparison day (UTC) gets a warning icon regardless of active status. The icon only indicates that the date has passed. Active contracts with equal elapsed dates also appear as warning rows.",
        notRenewedInWebkua: "Not renewed in WK", notRenewedInSalesforce: "Not renewed in SF",
        renewalAssessment: "Renewal assessment", differentRenewalDates: "Different renewal dates",
        matchingRenewalDates: "Matching renewal dates", renewalUnresolved: "Renewal dates cannot be compared reliably",
        billingMappings: "Contract responsible is compared to Bill_to_Contact__r.Email. Invoice customer is compared to BillToAccount__r.WebKuaCustomerNumber__c. WK uses the invoice customer number, falling back to the contract customer when the stored invoice number is empty. Missing invoice information is unresolved. Seller is not compared.",
        warningsTitle: "Warnings",
        warnings: { ExpiredWithoutEndDate: "SF status is Expired, but EndDate is missing.",
            ExpiredWithCurrentEndDate: "SF status is Expired, but EndDate is today or in the future.",
            ActivatedWithPastEndDate: "SF status is Activated, but EndDate has passed.",
            SalesforceRenewalDatePassed: "Renewal date has passed in SF",
            WebkuaRenewalDatePassed: "Renewal date has passed in WK" },
        orderLimitations: "Sync requires preview and confirmation and is offered only when the existing order can correct every field difference. The order does not support start date, invoice interval, invoice customer, activity changes or clearing fields on existing Contracts.",
        kinds: { MissingKey: "Missing SF contract number", AmbiguousContract: "Multiple contracts with the same SF number",
            MissingInSalesforce: "Contract only in WK", MissingInWebkua: "Contract only in SF",
            ComparisonBlocked: "Unresolved contract sources", CompanyMismatch: "Different customer", ActivityMismatch: "Different active status",
            FieldMismatch: "Different contract fields", SourceWarning: "Inconsistent SF status", RenewalWarning: "Elapsed renewal date" },
        fields: { companyNumber: "Customer number", isCurrent: "Active status", startDate: "Start date",
            nextRenewalDate: "Next renewal", terminationDate: "Termination date", maintenanceStopDate: "Maintenance stop",
            currency: "Currency", invoiceInterval: "Invoice interval (months)", invoicedCompanyNumber: "Invoice customer number",
            contractResponsibleEmail: "Contract responsible (email)", status: "SF status" },
        issues: { MissingContractNumber: "SF contract number is missing.", MissingCompanyNumber: "Customer number is missing.",
            MissingContractInfo: "WK contract information is missing.", UnknownActivity: "Contract activity is unresolved.",
            MissingStartDate: "Start date is missing.", MissingNextRenewalDate: "Next renewal date is missing.",
            InvalidInvoiceInterval: "Invoice interval is missing or invalid.", MissingCurrency: "Currency is missing.",
            MissingInvoiceInfo: "WK invoice information is missing.", MissingInvoicedCompanyNumber: "Invoice customer number is missing." },
    },
    reconciliationFilters: {
        syncFilter: "Synchronization", categoryFilter: "Check", all: "All", canSync: "Can synchronize",
    },
    salesforceInternal: {
        tab: "SF internal",
        requiresAll: "Fetch accounts, assets and contracts. All three must finish loading before SF internal is available.",
        missingEvidence: "SF source evidence is missing from the response. Update the API and refetch all three comparisons.",
        scope: "Read-only SF checks for WK-linked customers in the current NO comparison. Internal/test customers and offer products are excluded. Contracts are subscriptions and cancellation is immediate. Active contracts must have active recurring assets with the same end date. Support and one-off purchases are excluded from lifecycle checks. SF and WK can agree even when SF is inconsistent. Differences from contract renewal are warnings; different end dates among active assets are errors.",
        snapshots: "Assets fetched: {{assets}}. Contracts fetched: {{contracts}}. Reads are separate; intervening SF changes can cause temporary differences. The evaluation date follows the contract read.",
        noFindings: "No findings for the implemented checks in the fetched data. This is not a complete Salesforce validation.",
        severityFilter: "Severity", ruleFilter: "Check", all: "All",
        severity: { error: "Error", warning: "Warning", unevaluable: "Unable to evaluate" },
        sameEndDate: "Same end date for active assets",
        columns: { severity: "Severity", rule: "Finding", company: "Customer number", contractNumber: "SF contract",
            asset: "Asset", productCode: "Product code", assetStatus: "Asset status", contractStatus: "Contract status",
            usageEnd: "Asset end date", contractEnd: "Contract end date", renewal: "Next renewal",
            quantity: "Asset quantity", cancellation: "Cancellation date",
            installDate: "Asset installation date", contractStart: "Contract start date",
            actual: "Actual value", expected: "Reference / expected value" },
        rules: {
            IncompleteAssetEvidence: "Selected SF fields are missing from the asset response",
            UnknownAssetStatus: "Asset status cannot be interpreted", UnknownRecurrence: "Product recurrence is unresolved",
            MissingContract: "Active recurring asset has no contract", ContractNotFetched: "Asset contract is not in the fetched scope",
            AmbiguousContract: "Multiple fetched contracts have the same SF ID", MissingAccount: "Asset or contract account ID is missing",
            AccountMismatch: "Asset and contract belong to different SF accounts", UnknownContractStatus: "Contract status cannot be interpreted",
            InvalidDate: "An SF date cannot be interpreted", ActiveOnCancelledContract: "Active asset on cancelled contract",
            ActiveOnExpiredContract: "Active asset on expired contract", ActiveOnDraftContract: "Active asset on draft contract",
            ActiveOnPastEndedContract: "Active asset on contract with a past end date",
            UsageBeyondContractEnd: "Asset end date is later than contract end date",
            MissingUsageEnd: "Active recurring asset has no end date", PastUsageEnd: "Active asset has a past end date",
            MissingRenewalDate: "Renewal check needs the contract's next renewal date",
            RenewalMisalignment: "Asset end date differs from the day before next renewal",
            ActiveContractWithoutAssets: "Active subscription contract has no active recurring assets",
            IncompleteContractAssets: "Incomplete asset data prevents assessment of the contract's active assets",
            ActiveAfterCancellation: "Asset remains active on or after its cancellation date",
            InconsistentAssetEndDates: "Active assets on one contract have different end dates",
            ActivatedWithPastEndDate: "Activated contract has a past end date",
            ExpiredWithoutEndDate: "Expired contract has no end date",
            ExpiredWithCurrentEndDate: "Expired contract has an end date today or in the future",
            SalesforceRenewalDatePassed: "Active contract has a past renewal date",
            InvalidQuantity: "Active licence asset has missing or invalid quantity",
            ActiveZeroQuantity: "Active licence asset has zero quantity",
            ContractEndBeforeStart: "Contract end date precedes its start date",
            ContractRenewalBeforeStart: "Contract renewal date precedes its start date",
            MissingContractIdentity: "Contract has no SF ID",
            IncompleteLifecycleEvidence: "Selected date or cancellation fields are missing from the asset response",
            AssetStartAfterEnd: "Asset installation date is later than its end date",
            ActiveOnFutureContract: "Active asset on a contract with a future start date",
            CancellationBeforeAssetStart: "Asset cancellation date precedes its installation date",
            CancelledWithoutCancellationDate: "Cancelled recurring asset has no cancellation date",
        },
    },
    salesForceMetadata: {
        title: "Salesforce metadata",
        object: "Object type",
        fetch: "Fetch metadata",
        loading: "Fetching Salesforce field metadata...",
        error: "Could not fetch Salesforce field metadata.",
        loaded: "{{objectName}}: {{count}} fields",
        name: "Field name",
        label: "Label",
        type: "Field type",
        referenceTo: "References",
        relationshipName: "Relationship name",
    },
    salesForceAssetReconciliationSync: {
        field: "Field", salesforceValue: "SF quantity", webkuaValue: "WK quantity", fields: { quantity: "Quantity" },
        sync: {
            column: "Action", button: "Sync SF → WK", warningButton: "Sync SF → WK (warning)",
            savedButton: "Order recorded", title: "Sync {{number}} from SF to WK",
            tooltip: "Will sync from SF to WK: {{fields}}.",
            description: "Submits an Asset order with the previewed quantity. Active quantity only in WK means stopping; only in SF means creation in WK. The link is checked before submission but may change before execution.",
            actions: {
                Update: "Updates quantity on the existing item line. Discount and other fields are preserved.",
                Stop: "Terminates the existing item line with quantity 0. The licence is also terminated if no active seats remain.",
                CreateLicense: "Creates a new WK licence with quantity and discount from SF.",
                CreateItem: "Creates a new item line on the existing WK licence with quantity and discount from SF."
            },
            usedWarning: "Warning: The licence was used in 2026, most recently on {{date}}. Sync terminates the item line and may remove access that is still in use.",
            reduceWarning: "Quantity is reduced from {{from}} to {{to}}. This reduces seats but does not terminate the item line.",
            stopWarning: "Quantity changes from {{from}} to 0. The item line is terminated. The licence is also terminated if no active seats remain.",
            preview: "Fresh quantity difference before sync", loading: "Checking or submitting order …",
            confirm: "Confirm and submit order", close: "Close", newPreview: "Fetch a new preview",
            retry: "Check the same submission", refresh: "Recheck report",
            submitted: "The order was submitted. Execution is not confirmed. Check order status and reload the report after execution.",
            recorded: "The order is already saved and was not resent. Check order status.",
            orderId: "Order ID: {{id}}",
            errors: {
                InvalidPreview: "The confirmation expired or is invalid. Fetch a new preview.",
                SourceChanged: "SF, WK or product data changed. Fetch a new preview.",
                AmbiguousLink: "Cannot sync: the customer, Contract or item line link is not unique.",
                NoDifferences: "No quantity differences to sync now. Reload the report.",
                MultipleTargets: "Cannot sync: multiple licences or item lines can be selected. Manual repair is required.",
                DiscountUnsupported: "Cannot sync: discount differences or distributions cannot be corrected by this action.",
                ProductUnresolved: "Cannot sync: the product mapping is missing or ambiguous.",
                InactiveTarget: "Cannot sync: the selected item line is terminated, or there is no active item line to stop. The order does not reactivate terminated item lines.",
                ParentUnresolved: "Cannot sync: the module requires one unique active parent licence on the same Contract.",
                UnsafeSource: "Cannot sync: SF quantity, status or product evidence is unresolved.",
                UnsafeTarget: "Cannot sync: WK item lines have invalid product, discount or seat data.",
                InvalidQuantity: "Cannot sync: quantity must be an integer from 0 to 2147483647.",
                IncompleteSource: "Cannot sync: required source or target information is missing. Reload the report.",
                UnsupportedDifference: "Cannot sync: this discrepancy cannot be corrected with a quantity, termination or creation order.",
                OperatorUnresolved: "The signed-in user cannot be uniquely matched to a WK user.",
                PendingOrder: "Cannot sync: an Asset order for the same Contract and item is already open.",
                OrderConflict: "An existing order could not be safely matched to this action. Check the order.",
                DispatchFailed: "The order was saved, but dispatch was not confirmed. Check it before another sync.",
                RequestFailed: "The request could not be confirmed. The order may already be saved. Check the same submission or order status before another sync."
            }
        }
    },
    salesForceAssetReconciliation: {
        contracts: "Contract",
        item: "Item",
        sfQuantity: "Qty SF",
        wkQuantity: "Qty WK",
        renewal: "Expiry / renewal",
        usage: "Usage (2026)",
        sync: "Sync",
        chooseAssets: "Choose Salesforce Asset",
        assetChoice: "{{number}}. {{name}} - {{status}}, quantity {{quantity}}, expiry {{date}}",
        otherContractBadge: "Possible wrong contract",
        afterRenewalBadge: "After renewal",
        renewalUseUnknown: "Usage recorded, but renewal date is missing or ambiguous",
        syncPlanned: "Planned",
        syncOverdue: "Overdue, open",
        syncSummary: "{{state}}: {{quantity}} / {{date}}",
        pendingUnknown: "Open order, summary unknown",
        quickFilters: "Quick filters",
        clearFilters: "Clear filters",
        showDiscount: "Show discount",
        filteredRows: "Showing {{shown}} of {{total}} rows",
        salesforceUsageEndDates: "Salesforce item end date (UsageEndDate)",
        dateSources: "SF: item end date (UsageEndDate). WK: next contract renewal date.",
        aboutComparison: "About the comparison",
        detailsQuantityMismatch: "Different active quantities: SF {{sfQuantity}}, WK {{wkQuantity}}.",
        detailsSfOnly: "{{sfQuantity}} active in Salesforce – no active WK item line on this contract.",
        detailsWkOnly: "{{wkQuantity}} active in WebKUA – no active SF Asset on this contract.",
        sourceEndDate: "End date (SF)",
        sourceContractRenewal: "Contract renewal (WK)",
        noActiveSourceAssets: "No active SF Asset on this contract.",
        noActiveSourceItems: "No active WK item line on this contract.",
        candidateEvidenceOnly: "Candidates, not reliably matched item lines.",
        sourceSummary: "{{sfCount}} SF Assets and {{wkCount}} WK item lines. Shown active quantities: SF {{sfQuantity}}, WK {{wkQuantity}}.",
        quantityExplanation: "SF sums Quantity for Active Assets, not Renewal Quantity. Inactive and Cancelled Assets are excluded from product reconciliation. WK is checked independently and sums item lines where both the licence and line are active. Unresolved links are not reliably compared.",
        discountAllocation: "Discount allocation",
        productMatchIssue: "Item mapping",
        productCandidates: "Possible WK items for the SF product code",
        productCandidatesExplanation: "These are candidates on the same customer and contract, not reliably matched item lines. Quantities are not used to select the item.",
        UnknownProductCode: "The SF product code has no known WK item",
        AmbiguousProductCode: "The SF product code maps to multiple possible WK items",
        identifiedItemMissingCounterpart: "The item is identified on this customer and contract. Only one side has an active counterpart. - denotes a missing source record, not an unresolved item mapping.",
        noMatchedSourceItems: "No reliably matched WK item lines.",
        companyComparisonTitle: "Same customer and item across contracts",
        netDifference: "Net quantity difference (SF − WK)",
        netDiscountDifferences: "Net difference per discount (SF − WK)",
        discrepanciesOnly: "Only contract discrepancies are shown, not full company quantities. In-sync contracts contribute zero difference and are omitted. Reliable absence of an item counts as 0 in the difference, but is still displayed as -.",
        companyComparison: {
            ContractDistributionMismatch: "Quantity and discount differences cancel – different contract allocation",
            QuantityBalancedDiscountMismatch: "Quantities cancel – different overall discount allocation",
            QuantityMismatch: "Net quantities differ",
            DiscountMismatch: "Overall discount allocation differs",
            ComparisonBlocked: "Cross-contract comparison is unresolved",
        },
        discountPrecision: "Quantities are compared per discount rounded to {{decimals}} decimals. Split licences are OK when allocations match. Empty SF discount means 0%. Missing WK discount or invalid discount remains unresolved.",
        unknownDiscount: "Unresolved discount",
        discountGroupSummary: "{{discount}}: SF {{sfQuantity}}, WK {{wkQuantity}}",
        DiscountMismatch: "Same total quantity, but different quantities per discount",
        DiscountComparisonBlocked: "Discount allocation cannot be compared reliably: missing/invalid discount or negative active quantity",
        sourceDetailsUnavailable: "Source details are missing from the API response. Rebuild and restart the API, then fetch again.",
        noSourceAssets: "No Salesforce sources in this row.",
        noSourceItems: "No WebKUA sources in this row.",
        sourceAsset: "Asset / product code",
        sourceStatus: "Status",
        sourceQuantity: "Quantity",
        sourceActiveQuantity: "Active quantity",
        renewalQuantity: "Renewal quantity",
        excludedFromRenewal: "Excluded from renewal",
        cancellation: "Cancellation",
        sourceActive: "Active",
        sourceInactive: "Inactive",
        sourceLicense: "Licence",
        sourceItem: "Item line",
        sourceDiscount: "Discount (%)",
        sourceDates: "Termination / expiry",
        sourceMaintenance: "Maintenance",
        sourceRenewal: "Renewal",
        noUsage2026: "No recorded usage in 2026",
        usageIsLicenseLevel: "Usage is licence-level, not necessarily this item. Use after renewal does not prove missing invoicing.",
        oneTimeExcluded: "One-time item - excluded from reconciliation",
        filters: {
            afterRenewal: "Used after renewal",
            recent: "Used in last 30 days",
            otherContract: "Possible wrong contract",
            contractDistribution: "Differences cancel across contracts",
            discountMismatch: "Discount allocation differs",
            pending: "Open sync order",
            unresolved: "Unresolved comparison",
            sfZeroWkPositive: "SF = 0, WK > 0",
        },
        compactStatus: {
            wkOnlyActive: "Active quantity only in WK",
            sfOnlyActive: "Active quantity only in SF",
            MissingInWebkua: "Active quantity only in SF",
            MissingInSalesforce: "Active quantity only in WK",
            UnknownProductCode: "Unknown SF product code",
            AmbiguousProductCode: "Ambiguous SF product code",
            QuantityMismatch: "Quantity differs",
            DiscountMismatch: "Discount allocation differs",
            DiscountComparisonBlocked: "Unresolved discount allocation",
            DuplicateWebkuaLicenses: "Same quantity, multiple licences",
            ComparisonBlocked: "Unresolved link",
            UnmappedWebkuaItem: "Unresolved WK item",
            UnmappedProduct: "Unknown/ambiguous item",
            MissingKey: "Missing match key",
            UnclassifiedAsset: "Unknown SF status/quantity",
            AmbiguousContract: "Ambiguous contract",
        },
        inSyncGroups: "{{inSync}} of {{compared}} reliably compared customer–contract–item groups have matching quantities and discount allocations.",
        noComparableGroups: "0 of 0 groups in sync: No customer–contract–item groups could be compared reliably.",
        pendingOrders: "{{count}} open Asset orders are pending in WebKUA. They are not included in current licence quantities.",
        pendingOrderId: "Order ID",
        hasPendingOrders: "Open sync order",
        latestPendingQuantity: "Latest target quantity",
        latestPendingActivationDate: "Latest sync scheduled for",
        latestPendingUnresolved: "The latest open sync order could not be determined for the following customer/contract/item rows. Their target quantity and date are not shown:",
        webkuaContractNumber: "WebKUA contract number",
        webkuaContractRenewalDates: "WebKUA renewal date",
        pendingQuantity: "Planned quantity",
        activationDate: "Planned activation",
        deferredAssetFields: "Reliably matched active quantities and discount allocations are compared. Missing contract links, unknown statuses or products, historical Assets, and other Asset fields remain unresolved.",
        contractNumber: "Salesforce contract number",
        productCode: "Salesforce product code",
        salesforceDiscount: "SF discount (%)",
        lastUsedDate2026: "Last recorded usage date in WebKUA (2026)",
        usedAfterRenewalDate: "Used after renewal date (2026)",
        otherWebkuaContracts: "Active item on other WebKUA contracts (possible matches)",
        otherContractItem: "{{contractNumber}}: {{quantity}} (licence {{licenseNumbers}})",
        candidateContracts: "Possible SF contracts (customer/item only)",
        itemId: "Item ID",
        salesforceActiveQuantity: "Salesforce active quantity",
        webkuaActiveQuantity: "WebKUA active quantity",
        salesforceAssetIds: "Salesforce Asset IDs",
        webkuaLicenseNumbers: "WebKUA licence numbers",
        duplicateWebkuaLicenseNumbers: "Multiple active WebKUA licences (information)",
        DuplicateWebkuaLicenses: "Same quantity split over multiple active WebKUA licences; older result without discount reconciliation",
        licenseTerminationDates: "Licence termination date (by licence no.)",
        maintenanceExpirationDates: "Maintenance expiration date (by licence no.)",
        itemTerminationDates: "Item termination date (by licence no.)",
        webkuaContractIds: "WebKUA contract IDs",
        AmbiguousContract: "Multiple WebKUA contracts share the Salesforce number – items not compared",
        UnmappedProduct: "Unmapped or ambiguous product",
        MissingKey: "Missing company or contract number",
        UnclassifiedAsset: "Unclassified Asset status or quantity",
        UnmappedWebkuaItem: "WebKUA item without a reliable customer, contract or item link",
        MissingInWebkua: "SF has active quantity; WK has no active item line for the same customer, contract and item",
        MissingInSalesforce: "WK has active quantity; SF has no active Asset for the same customer, contract and item",
        ComparisonBlocked: "Unresolved link: known quantities only, not compared",
        ActivationMismatch: "Only one side has active quantity",
        QuantityMismatch: "Active quantities differ",
    },
    salesForceAssetSync: {
        itemId: "Webkua ID",
        licenseCount: "Items in Webkua",
        orderCount: "Pending orders",
        oldQuantity: "Quantity in Webkua",
        newQuantity: "New quantity",
        contractRenewalDate: "Contract renewal date",
        syncing: "Sync registered",
        manuallyHandled: "Manually handled",
        setAsManuallyHandled: "Set as manually handled",
        sync: "Sync",
    },
    "headerBar": {
        "yourUserSettings": "Your User Settings",
        "logOut": "Log Out",
        "yourRoles": "Your Roles: ",
    },
    "mainMenu": {
        licensing: "Licensing",
        administration: "Administration",
        troubleshooting: "Troubleshooting",
        courseAdministration: "Courses",
        showHiddenItems: "Show hidden",
        "navigation": "Navigation"
    },
    "companyDialog": {
        "companyIsCreated": "Company is created.",
        "couldNotCreateCompany": "Could not create company.",
        "requestDenied": "Request denied.",
        "couldNotDeclineRequest": "Could not decline request."
    },
    "companyRequest": {
        "requests": "Requests",
        userAddedInfo: "User added info",
        followUpSellerName: "Follow up seller name",
        "isForeign": "Foreign company",
        "country": "Country",
        status: "Status",
        "DoesNotExist": "orgnr Finnes ikke i Superoffice",
        "ExistsInCRM": "orgnr finnes i Superoffice",
        "ExistsInWebkua": "orgnr finnes i Webkua",
        "companiesOutsideBrønnøysund": "Companies outside Brønnøysund",
        chooseFollowUpSeller: "Choose follow up seller",
    },
    "futureRenewals": {
        "futureRenewals": "Future Renewals"
    },
    "orders": {
        "orders": "Orders"
    },
    "autodeskOpportunities": {
        "address": "Address",
        csn: "CSN",
        companyName: "Firmanavn",
        "companyNumber": "Company number",
        "contractManagerEmail": "Contract manager email",
        "contractManagerName": "Contract manager name",
        "status": "Status",
        "quantity": "Quantity",
        costPrice: "Cost price",
        "purPriceEur": "Pur price EUR",
        "renewalSkus": "Renewal SKUs",
        "skuDescriptions": "SKU descriptions",
        "endDate": "End date",
        "renewalSku": "Renewal SKU",
        "skuDescription": "SKU description",
        hasExistingOrder: "Has existing order",
        createOrder: "Create order",
    },
    "autodeskCatalog": {
        "title": "Autodesk catalogue",
        "subtitle": "Choose which Autodesk products to create in Webkua",
        "private": "Private (Agency)",
        "product": "Product",
        "code": "Code",
        "sellable": "Sellable",
        "status": "Status",
        "imported": "Created",
        "select": "Select",
        "selected": "Selected",
        "update": "Update",
        "updated": "updated",
        "createProducts": "Create/update products",
        "term": "Term",
        "orderAction": "Type",
        "newSale": "New",
        "renewal": "Renewal",
        "quantity": "Quantity",
        "servicePlan": "Service plan",
        "discountProgram": "Discount programme",
        "priceAfterDiscounts": "Price after discounts",
        "specialPrograms": "Discount programmes",
        "description": "Description",
        "noVariants": "No discount programmes",
        "programs": "Programmes",
        "products": "products",
        "priceMismatches": "Price mismatches",
        "renewalOnly": "Renewal only",
        "setupId": "New sale ID",
        "recurringId": "Renewal ID",
        "blocked": "Cannot be created",
        "priceDrift": "Price change",
        "created": "created",
        "skipped": "skipped",
        "priceDifference": "Price difference",
        "newSaleEur": "New sale (EUR)",
        "newSaleNok": "New sale (NOK)",
        "renewalEur": "Renewal (EUR)",
        "renewalNok": "Renewal (NOK)",
        "eurToNokRate": "EUR to NOK rate",
        "saveRate": "Save rate",
        "rateSaved": "Rate saved",
        "notSet": "not set",
        "invalidRate": "Invalid rate",
        "government": "Government (Synnex price list)",
        "uploadPriceList": "Upload price list",
        "dropOrClick": "Drag and drop the file here, or click to browse",
        "renewalVariants": "Transition prices",
        "showTransitionPrices": "Show transition prices",
        "earnback": "Earn-back",
        "costPrice": "Cost price",
        "skippedRows": "Skipped rows",
        "hasIssue": "Flagged",
        "collapsedVariantsMessage": "Several variants (service plan or access model) were merged into this row -- there may be a separate product not shown here.",
        "unknownOrderActionMessage": "Autodesk has flagged this row with an action we don't recognise -- the price has not been calculated for this variant.",
        "unexpectedPairMessage": "Missing a new-sale or renewal side, without the product being past end-of-sale -- worth checking before selling."
    },
    "adminChangeContracts": {
        "contractUpdated": "Contract updated",
        "contractStatus": "Contract Status",
        "active": "Active",
        "expired": "Expired",
        "updateContract": "Update Contract"
    },
    "adminChangeContractLicense": {
        "updatedExpirationDate": "Updated expiration date",
        "updatedParentLicenseNumber": "Updated parent license number",
        "updatedItemType": "Updated item type",
        "changeLicense": "Change License",
        "updateExpirationDate": "Update expiration date"
    },
    "adminCompany": {
        "moveUsersToNewCompany": "Move users to new company"
    },
    "baseCatalog": {
        "updatedCourseInCatalog": "Updated course in catalog.",
        "couldNotUpdateCourseInCatalog": "Could not update course in catalog.",
        "linkToCourseCatalog": "Link to course catalog",
        "icon": "Icon",
        "preamble": "Preamble",
        "categories": "Categories",
        "selectLevel": "Select level",
        "selectDuration": "Select duration"
    },
    "bronnoysundAdmin": {
        "syncWithBronnoysund": "Sync. with Brønnøysund",
        "soName": "SO name",
        "bsName": "Brreg name",
        "soAddress": "SO address",
        "bsAddress": "Brreg address",
        "bsZip": "Brreg zipcode",
        "soZip": "SO zipcode",
        "bsPostZip": "Brreg postal zipcode",
        "soPostZip": "SO postal zipcode",
        "bsCity": "Brreg city",
        "soCity": "SO city",
        "bsPostCity": "Brreg postal city",
        "soPostCity": "SO postal city",
        "soPostAddress": "SO postal address",
        "bsPostAddress": "Brreg postal address",
        "activeContracts": "No. active contracts",
        "bankruptInBS": "Bankrupt in Brreg",
        "liquidating": "Liquidating",
        "differentAddress": "Different address",
        "differentPostAddress": "Different postal address",
        "differentName": "Different name",
        "different": "Different"
    },
    "bronnoysundDetails": {
        "numberOfEmployees": "Number of employees",
        "postalCode": "Postal code",
        "city": "City",
        "district": "District",
        "bankrupt": "Bankrupt",
        "liquidating": "Liquidating"
    },
    "changeCourseUsersPassword": {
        "selectPassword": "Select password",
        "selectEmails": "Select emails",
        "changePasswordsForCourseUsers": "Change passwords for course users",
        "untilDate": "Until date",
        "courseName": "Course name (optional)",
        "passwordForCourseUsers": "Password for course users",
        "generateNewPassword": "Generate new password",
        "usedFrom": "Used from",
        "usedUntil": "Used until",
        "inUse": "In use",
        "useEmail": "Use email"
    },
    "companiesCreated": {
        "adminEmail": "Admin email",
        "adminName": "Admin name"
    },
    "contractDetailsContainer": {
        "startingSale": "Starting sale.",
        "futureChangesAreImplemented": "Future changes implemented",
        "orderDeleted": "Order deleted.",
        "couldNotDeleteOrder": "Could not delete order.",
        "orderHiddenRememberToOpenItAgainAfterChanges": "Order hidden, remember to open it again after changes.",
        "couldNotHideOrder": "Could not hide order."
    },
    "contractSale": {
        "approval": "Approval",
        "grantLicenseAccess": "Grant license access",
        "newSale": "New sale",
        "makeSale": "Make sale",
        "newLicense": "New license",
        "internalMessage": "Internal message"
    },
    "deleteCatalog": {
        "deletedCourseFromCatalog": "Deleted course from catalog.",
        "couldNotDeleteCourseFromCatalog": "Could not delete course from catalog."
    },
    "catalog": {
        "courseCatalog": "Course catalog"
    },
    "courseGrid": {
        "registrations": "Registrations",
        "noConflict": "No conflict",
        "firstNameInstr": "First name instr.",
        "lastNameInstr": "Last name instr.",
        "hideCanceled": "Hide canceled",
    },
    "createNewCourse": {
        "addedCourseToList": "Added course to list.",
        "couldNotAddCourseToList": "Could not add course to list.",
        "preamble": "Preamble",
        "superOfficeComments": "SuperOffice comments",
        "addNewCourse": "Add new course"
    },
    "deleteCourse": {
        "areYouSureYouWantToDeleteCourse": "Are you sure you want to delete the course?"
    },
    "registrationConflict": {
        "noDataFound": "No data found.",
        "conflicts": "Conflicts"
    },
    "evaluationEmail": {
        "nameOfTemplate": "Name of template",
        "template": "Template"
    },
    "externalCourses": {
        "confirmationOfCourseToRegistrant": "Confirmation of course to registrant"
    },
    "emailTemplates": {
        "emailTemplates": "Email templates",
        "evaluationEmail": "Evaluation email",
        "externalCourses": "External courses",
        "confirmationOfCourseRegistration": "Confirmation of course registration",
        "movingCourses": "Moving courses",
        "cancelingCourse": "Canceling course"
    },
    "tableData": {
        "explanationsOfVariousCodes": "Explanations of various codes",
        "updatedText": "Updated text.",
        "couldNotUpdateText": "Could not update text.",
        "address": "Address",
        "comment": "Comment",
        "userAddress": "User's address",
        "userPostCode": "User's postcode",
        "userCity": "User's city",
        "company": "Company",
        "courseName": "Course name",
        "coursereginfo": "Course information",
        "date": "Date",
        "dateOld": "Previous date",
        "duration": "Duration",
        "durationOld": "Previous duration",
        "email": "Email",
        "firstName": "First name",
        "lastName": "Last name",
        "mobile": "Mobile number",
        "place": "Place",
        "googleMapsLink": "Link to map",
        "price": "Price",
        "priceInfo": "Price information"
    },
    "informationTexts": {
        "informationTexts": "Information texts",
        "courseSchedule": "Course schedule",
        "generalInformation": "General information",
        "practicalInformation": "Practical information",
        "preamble": "Preamble",
        "general": "General",
        "practical": "Practical"
    },
    "cancelRegistration": {
        "canceledCourseParticipant": "Canceled course participant.",
        "couldNotCancelCourseParticipant": "Could not cancel course participant.",
        "areYouSureYouWantToCancelYourRegistration": "Are you sure you want to cancel your registration?",
        "sendEmailTo": "Send email to",
        "cancel": "Cancel"
    },
    "createNewRegistration": {
        "addedCourseParticipantToList": "Added course participant to list.",
        "couldNotAddCourseParticipantToList": "Could not add course participant to list.",
        "newCourseParticipant": "New course participant",
        "sendEmailWhenRegistering": "Send email when registering",
        "createNewCourseParticipant": "Create new course participant"
    },
    "editRegistration": {
        "changedCourseParticipantInList": "Changed a course participant in the list.",
        "couldNotChangeCourseParticipantInList": "Could not change a course participant in the list.",
        "changeCourseParticipant": "Change course participant",
        "sendEmailOnUpdating": "Send email on updating",
        "updateCourseParticipant": "Update course participant"
    },
    "moveRegistration": {
        "movedRegistration": "Moved registration.",
        "couldNotMoveRegistration": "Could not move registration.",
        "areYouSureYouWantToMoveCourseDate": "Are you sure you want to move course date?",
        "sendEmailTo": "Send email to",
        "moveDate": "Move date"
    },
    "reactivateRegistration": {
        "reactivatedCourseParticipant": "Reactivated course participant.",
        "couldNotReactivateCourseParticipant": "Could not reactivate course participant.",
        "areYouSureYouWantToReactivateYourRegistration": "Are you sure you want to reactivate your registration?",
        "sendEmailTo": "Send email to"
    },
    "registrationGrid": {
        "cancel": "Cancel",
        "reactivate": "Reactivate",
        "registered": "Registered",
        "cancelled": "Cancelled",
        "newCourseParticipant": "New course participant",
        "enrolled": "Enrolled",
        "sendEvaluation": "Send evaluation"
    },
    "registration": {
        "courseDate": "Course date"
    },
    "courseReport": {
        "theseAreOnCourse": "These are on course",
        "courseDeliveredDuringPeriod": "Course delivered during period",
        "includeParticipantsFromFocus": "Include participants from Focus",
        "numberOfParticipants": "Number of participants"
    },
    "emailLog": {
        "subject": "Subject"
    },
    "sendCertificate": {
        "courseCertificateSent": "Course certificate sent",
        "errorWhenSendingCourseCertificate": "Error when sending course certificate",
        "areYouSureYouWantToSendCourseCertificates": "Are you sure you want to send course certificates?"
    },
    "totalReport": {
        "sendCourseCertificateAgain": "Send course certificate again",
        "sendCourseCertificate": "Send course certificate",
        "showCourseCertificate": "Show course certificate",
        "dateOfOrder": "Order date"
    },
    "reports": {
        "course": "Course",
        "search": "Search",
        "emailLog": "Email log"
    },
    "createNewCategory": {
        "addCategoryToList": "Added category to list.",
        "couldNotAddCategoryToList": "Could not add category to list.",
        "addCategory": "Add category"
    },
    "deleteCategory": {
        "deletedCategoryFromList": "Deleted category from list.",
        "couldNotDeleteCategoryFromList": "Could not delete category from list.",
        "areYouSureYouWantToDeleteCategory": "Are you sure you want to delete category?"
    },
    "editComputerEquipment": {
        "updatedComputerEquipmentInList": "Updated computer equipment in list.",
        "couldNotUpdateComputerEquipmentInList": "Could not update computer equipment in list.",
        "updateComputerEquipment": "Update computer equipment"
    },
    "computerEquipment": {
        "serialNumber": "Serial number"
    },
    "createNewDuration": {
        "addedNewDurationToList": "Added new duration to list.",
        "couldNotAddNewDurationToList": "Could not add new duration to list.",
        "value": "Value",
        "unit": "Unit",
        "hours": "hours",
        "days": "days",
        "addDuration": "Add duration"
    },
    "deleteDuration": {
        "deletedDurationFromList": "Deleted duration from list.",
        "couldNotDeleteDurationFromList": "Could not delete duration from list.",
        "areYouSureYouWantToDeleteDuration": "Are you sure you want to delete duration?"
    },
    "copyInstructor": {
        "createInstructor": "Create instructor"
    },
    "createNewInstructor": {
        "addInstructor": "Add instructor"
    },
    "deleteInstructor": {
        "deletedInstructorFromList": "Deleted instructor from list.",
        "couldNotDeleteInstructorFromList": "Could not delete instructor from list.",
        "areYouSureYouWantToDeleteInstructor": "Are you sure you want to delete instructor?"
    },
    "editInstructor": {
        "changedInstructorInList": "Changed instructor in list.",
        "changeInstructor": "Change instructor",
        "updateInstructor": "Update instructor"
    },
    "createNewLevel": {
        "addedLevelToList": "Added level to list.",
        "couldNotAddLevelToList": "Could not add level to list.",
        "addLevel": "Add level",
        "deletedLevelFromList": "Deleted level from list.",
        "couldNotDeleteLevelFromList": "Could not delete level from list.",
        "areYouSureYouWantToDeleteLevel": "Are you sure you want to delete level?"
    },
    "deletePicture": {
        "deletedImageFromList": "Deleted image from list.",
        "couldNotDeleteImageFromList": "Could not delete image from list.",
        "areYouSureYouWantToDeletePicture": "Are you sure you want to delete picture?"
    },
    "picture": {
        "uploadNewImage": "Upload new image"
    },
    "copyPlace": {
        "couldNotAddPlace": "Could not add place.",
        "createPlace": "Create place"
    },
    "createNewPlace": {
        "couldNotAddLocationToList": "Could not add location to list.",
        "addLocation": "Add location"
    },
    "deletePlace": {
        "deletedPlaceFromList": "Deleted place from list.",
        "couldNotDeleteLocationFromList": "Could not delete place from list.",
        "areYouSureYouWantToDeleteLocation": "Are you sure you want to delete location?"
    },
    "editPlace": {
        "updatedPlace": "Updated place.",
        "couldNotUpdatePlace": "Could not update place.",
        "changeLocation": "Change location",
        "updateLocation": "Update location"
    },
    "place": {
        "updateFromSuperOffice": "Update from SuperOffice"
    },
    "createNewPrice": {
        "addedPriceToList": "Added price to list.",
        "couldNotAddPriceToList": "Could not add price to list.",
        "priceFormat": "Price format",
        "addPrice": "Add price"
    },
    "deletePrice": {
        "deletedPriceFromList": "Deleted price from list.",
        "couldNotDeletePriceFromList": "Could not delete price from list.",
        "areYouSureYouWantToDeletePrice": "Are you sure you want to delete price?"
    },
    "resources": {
        "resources": "Resources"
    },
    "courses": {
        "courseAccess": "Course access",
        "usedFrom": "In use from",
        "usedUntil": "In use until",
        "passwordForCourse": "Password for course",
        "createNewCourse": "Create new course",
        "numberOfParticipants": "Number of participants",
        "coursePrice": "Course price",
        "includeCanceledCourses": "Include canceled courses",
        "answeredSurvey": "Answered survey",
        "sentCertificate": "Sent certificate"
    },
    "createEmail": {
        "emailInternalName": "Email internal name",
        "createEmail": "Create email"
    },
    "addContract": {
        "newContract": "New contract",
        "thereAreNoAccountsForThisCustomer": "There are no accounts for this customer. Create a person in the company before creating a contract.",
        "months": "months",
        "year": "year",
        "contractStart": "Contract start",
        "contractRenewal": "Renewal date",
        "selectContractType": "Select contract type",
        "retrievesEmployees": "Retrieves employees"
    },
    "addCustomerGroup": {
        "companyAddedToGroup": "Company added to group.",
        "couldNotAddCompanyToGroup": "Could not add company to group."
    },
    "addImport": {
        "ticketID": "Ticket ID",
        "usedTime": "Used time",
        "numberOfMessages": "Number of messages"
    },
    "addNewUser": {
        "contractUpdated": "Contract updated.",
        "cannotHaveMoreUsersThanThereAreSeats": "Cannot have more users than there are seats.",
        "updatesUsersOnContract": "Updates users on contract.",
        "numberOfUsersOnContract": "Number of users on the contract"
    },
    "allContractsDetailsGrid": {
        "pricePerItem": "Price per item",
        "monthlyValue": "Monthly value",
        "netGain": "Net gain",
        "residualValueAtYearStart": "Residual value at year start",
        "totalCost": "Total cost"
    },
    "allContractsGrid": {
        "invoiceResponsible": "Invoice responsible",
        "futureChanges": "Future changes",
        "invoiceInterval": "Contract duration"
    },
    "assignLicenseRight": {
        "changesLicenseAccess": "Changes license access.",
        "couldNotChangeLicenseRights": "Could not change license rights."
    },
    "basicCustomerDetails": {
        "seeCustomerInformationInSuperOffice": "See customer information in SuperOffice",
        "customerContact": "Customer contact",
        "companySettings": "Company settings",
        "administrator": "Administrator",
        "language": "Language",
        "requiresTwoFactorAuthentication": "Requires 2FA",
        "federatedDomain": "Federated domain"
    },
    "basicSupport": {
        "contractNumber": "Contract number",
        "seeNext": "See next",
        "agreementType": "Agreement type",
        "includedForGroup": "Support included for the group",
        "includedInSubscription": "Support included in the subscription",
        "groupDeal": "Group deal",
        "individualDeal": "Individual deal",
        "noRestrictions": "No restrictions",
        "users": " users",
        "nextInvoice": "Next invoice"
    },
    "ceateFocusAccount": {
        "emailIsNotValid": "The email is not valid.",
        "newInvitationSent": "New invitation sent.",
        "completingAccount": "Completing account.",
        "approvesFocusAccount": "Approves Focus account.",
        "createAccount": "Create account.",
        "sendNewInvitation": "Send new invitation",
        "completeAccount": "Complete account",
        "approveAccount": "Approve account",
        "openAccount": "Create account",
        "retrievesAccountStatus": "Retrieves account status",
        "createFocusAccount": " Create Focus account",
        "accountStatus": "Account status",
        requestedCompany: "Company user requests access to",
    },
    "credit": {
        "creditingDone": " Crediting done.",
        "couldNotPerformCrediting": "Could not perform crediting.",
        "amountAfterBalance": "Amount after balance",
        "message": "Message"
    },
    "customerDetails": {
        "focusAccounts": "Focus accounts",
        "peopleInSuperOffice": "People in SuperOffice",
        "companyGroup": "Company group",
        "createCompanyGroup": "Create company group",
        "loggedInToMyPage": "Logged in to My Page",
        "viewByGroup": "View by group",
        "showDeleted": "Show deleted"
    },
    "customerProductList": {
        "domains": "Domains",
        "coordinators": "Coordinators",
        "hasLicensing": "Has licensing",
        "items": "Items",
        "forGroup": "For group"
    },
    "customerProductListGrid": {
        "licenseTypeDoesNotHaveLicensing": "License type does not have licensing",
        "accessHistory": "Access history"
    },
    "customerProductListGridRenderer": {
        "removeOldAccesses": "Remove accesses older than",
        "givenAccess": "Given access",
        "removedAccess": "Removed access",
        "givenCoordinator": "Given coordinator",
        "removedCoordinator": "Removed Coordinator",
        "moved": "Moved",
        "productVersion": "Product version"
    },
    "deleteCustomerGroup": {
        "customerGroupDeleted": "Subsidiary removed.",
        "couldNotDeleteCustomerGroup": "Could not remove subsidiary.",
        "areYouSureYouWantToDeleteCompanyDepartment": "Are you sure you want to delete company / department?"
    },
    "domain": {
        "automaticDomainApprovalDone": "Automatic license approval done.",
        "failedToPerformAutomaticDomainValidation": "Could not perform automatic license approval.",
        "automaticDomainApproval": "Automatic license approval"
    },
    "editFocusAccount": {
        "reopenedFocusAccount": "Reopened Focus account.",
        "couldNotReopenFocusAccount": "Could not reopen Focus account",
        "changedAdmin": "Changed admin.",
        "changedToCoAdmin": "Changed to co-admin.",
        "resendingInvitation": "Resending invitation.",
        "deletesFocusAccount": "Deletes Focus account.",
        "changeFocusAccount": "Change Focus account",
        "changeCompany": "Change company",
        "selectAsAdmin": " Select as admin",
        "selectAsCoAdmin": "Select as co-admin",
        "resendInvitation": "Resend invitation",
        "reopenFocusAccount": "Reopen Focus account",
        "deleteWithoutEmail": "Delete without email",
        "deleteWithEmail": "Delete with email",
        "changeCompanyFor": "Change company for",
        "moveUserToNewCompany": "Move user to new company",
        "changeEmailFor": "Change email for",
        "retireInSO": "Retire in Superoffice",
        "requestedCompany": "Company the user requests access to",
        "resetMfa": "Reset MFA",
        selectAsUser: "Select as user",
    },
    "externalAccess": {
        "couldNotSelectCompanyToCustomer": "Could not select company to customer.",
        "selectCompanyToCustomer": "Select company to customer"
    },
    "license": {
        "canNotHaveMoreAccessesThanSeatsOnNamedUserLicenses": "Cannot have more accesses than seats on named user licenses.",
        "numberOfUsersOnLicense": "Number of users on the license"
    },
    "mergeContracts": {
        "combinesContracts": "Combines contracts",
        "targetContractNotSelected": "Target contract not selected",
        "selectTargetContract": "Select target contract"
    },
    "moveContracts": {
        "movingContracts": "Moving contracts",
        "selectCompanyYouWantToMoveTo": "Select company you want to move to",
        "hereYouCanSelectContractAndLicensesYouWantToMove": "Here you can select contract and licenses you want to move."
    },
    "orderOverview": {
        "orderDeleted": "Order deleted.",
        "couldNotDeleteOrder": "Could not delete order."
    },
    "support": {
        "noUserSupportAgreement": "No user support agreement"
    },
    "supportGrid": {
        "usersOnTheAgreement": "Users on the agreement",
        "transactions": "Transactions",
        "isOnSupport": "Is on support",
        "customerNoInNimbus": "Customer no. in Nimbus",
        "software": "Softwares",
        "estimatedHourlyBalance": "Estimated hourly balance",
        "spent": "Spent",
        "amountBalance": "Amount balance",
        "caseNo": "Case no.",
        "caseDate": "Case date",
        "transactionDate": "Transaction date",
        "text": "Text",
        "ownedBy": "Handled by",
        "hours": "Hours",
        "balance": "Balance",
        price15minutes: "Price per quarter",
        userOnSupportAgreement: "On support",
        ticketId: "Ticket ID",
        tickets: "Tickets",
        message: "Message",
        createdAt: "Created date",
        createdBy: "Created by",
        status: "Status",
    },
    "editCompanyDetails": {
        "changeCompanyDetails": "Change company details",
        "norwegian": "Norwegian",
        "english": "English",
        "twoFactorAuthentication": "Two-factor authentication",
        "noEmail": "no email",
        "selectCoAdministrators": "Select co-administrators",
        "federationAndSSO": "Federation and SSO",
        tenantId: "Tenant ID",
        clientId: "Client ID",
        domain: "Domain",
    },
    "editEmails": {
        "emailUpdated": "Email updated.",
        "triggerMade": "Trigger created.",
        "testEmailSent": "Test email sent",
        "triggerDeleted": "Trigger deleted",
        "shownToCustomer": "Shown to customer",
        "emailInternalName": "Email internal name",
        "updateEmailContent": "Update email content",
        "typeOfTrigger": "Type of trigger",
        "trigger": "Trigger",
        "missingEnglishEmail": "missing English email",
        "missingNorwegianEmail": "missing Norwegian email",
        "selectTrigger": "Select trigger",
        "newTrigger": "New trigger",
        "emailRecipient": "Email recipient",
        "forEnglishLanguage": "For English language",
        "saveEmailInSuperOffice": "Save email in SuperOffice",
        "numberOfDaysBetweenTriggerAndEvent": "Number of days between trigger and event",
        "updateTrigger": "Update trigger",
        "createTrigger": "Create trigger",
        "sendTestEmail": "Send test email",
        "deleteTrigger": "Delete trigger"
    },
    "editLicense": {
        "licenseChangesSaved": "License changes saved.",
        "endNow": "End now",
        "endAtTheNextDueDate": "End at the next due date",
        "custom": "Custom",
        "addNewItem": "Add new item",
        "dateOfSale": "Date of sale",
        "terminateLicense": "Terminate license",
        "change": "Change",
        "salePrice": "Sale price",
        "hasFutureChanges": "Has future changes"
    },
    "emailComponents": {
        "componentChanged": "Component changed.",
        "componentDeleted": "Component deleted",
        "saveComponent": "Save component",
        "deleteComponent": "Delete component"
    },
    "emailContainer": {
        "emailTemplates": "Email templates",
        "emailComponents": "Email components"
    },
    "emailList": {
        "immediately": "Immediately",
        "noTrigger": "No trigger",
        "triggerEvent": "Trigger event",
        "daysAfterEvent": "Days after event"
    },
    "errorLog": {
        "loginFailed": "Login failed",
        "userAgent": "User agent",
        "licenseNumber": "License number",
        "companyNumber": "Company number",
        "IPAdress": "IP address",
        "unavailableLicenses": "Unavailable licenses",
        "unavailableLicense": "Unavailable license",
        "request": "Request",
        "error": "Error",
        "inequalityOnUnit": "Inequality on unit",
        "oldValue": "Old value",
        "newValue": "New value"
    },
    "gptDefinations": {
        "newFunction": "New function",
        "getBackup": "Get backup",
        "functionName": "Function name",
        "shortDescriptionSoThatGptUnderstandsWhenToUseFunction": "Short description so that GPT understands when to use the function.",
        "content": "Content",
        "informationGptRetrievesWhenFunctionIsCalled": "The information GPT retrieves when the function is called.",
        "createNewFunction": "Create new function"
    },
    "gptHelper": {
        "findRightPage": "Find the right page",
        "pageAssistance": "Page assistance",
        "clearChat": "Clear chat",
        "writeAMessage": "Write a message..."
    },
    "gptOverview": {
        "pages": "Pages",
        "functions": "Functions"
    },
    "gptRouteDefinition": {
        "updatedRoute": "Updated route",
        "savedAsBackup": "Saved as backup",
        "newPage": "New page",
        "getBackup": "Get backup",
        "detailedDescriptionOfWhatIsOnPageSoGptCanAnswerQuestionsAboutPage": "Detailed description of what is on the page so GPT can answer questions about the page.",
        "detailedDescription": "Detailed description",
        "selected": "Selected",
        "saveRoute": "Save route"
    },
    "activeUsersGrid": {
        "version": "Version",
        "licenseNo": "License no.",
        "offline": "Offline",
        "maxSeats": "Max seats",
        "loggedInNow": "Logged in now",
        "onlyActiveUsers": "Only active users",
        "connected": "Connected",
        mainProductsOnly: "Only main products",
    },
    "loan": {
        "logOnDuration": "Logon duration",
        "timeZone": "Time zone",
        "newDevice": "New device"
    },
    "machine": {
        "diskID": "Disk ID"
    },
    "expiredLicense": {
        "subscription": "Subscription",
        "maintenance": "Maintenance"
    },
    licenseChanges: {
        terminatedLicenses: "Terminated licenses",
        reducedSeats: "Reduced seats",
        newSeats: "New seats",
        newLicenses: "New licenses",
    },
    "licenseUsageGrid": {
        "users": "Users",
        "logonsPerSeat": "Logons/Seat"
    },
    "machineInfo": {
        "windowsUsername": "Windows username",
        "domainName": "Domain name",
        "machineName": "Machine name",
        "localFolder": "Local folder",
        "systemSerialNumber": "System serial number",
        "systemDiskSignature": "System disk signature",
        "operatingSystem": "Operating system",
        "architecture": "Architecture"
    },
    "nlm": {
        "newOfflineFile": "New offline file",
        "existingOfflineFiles": "Existing offline files",
        "createOfflineNlm": "Create offline NLM"
    },
    "nlmGrid": {
        "generateNlmFile": "Generate NLM file",
        "downloadFile": "Download file",
        "offlineNlmFile": "Offline NLM file",
        "createFile": "Create file",
        NlmFileWillBeCreatedAndWillBeSentToYouByEmail: "The NLM file will be created and will be sent to you by email.",
    },
    "personActivityGrid": {
        "mergeProductsForUsers": "Merge products for users"
    },
    "rejectedLoginGrid": {
        "licensingSystem": "Licensing system",
        "approved": "Approved",
        "rejected": "Rejected",
        "rejectedPersent": "Rejected (%)"
    },
    "loginError": {
        "noLicense": "No license",
        "showDetails": "Show details"
    },
    "minSideInterests": {
        "addProductsTo": "Add products to"
    },
    "minSideStatus": {
        "changeSaved": "Change saved",
        "activateStatusMessageOnMyPage": "Activate status message on My Page",
        "statusMessageNorwegian": "Status message Norwegian",
        "statusMessageEnglish": "Status message English",
        "saveStatusMessage": " Save status message"
    },
    "monthlyReports": {
        "companyChurn": "Company churn (%)",
        "companyGrowth": "Company growth (%)",
        "licenseChurn": "Seat churn (%)",
        "licenseGrowth": "Seat growth (%)",
        "incomeChurn": "Income churn (%)",
        "incomeGrowth": "Income growth (%)",
        "licenseDiff": "Seat diff.",
        "incomeDiff": "MRR Income diff.",
        "incomeMRR": "MRR Income",
        "incomeARR": "ARR Income"
    },
    "moveContractInvoice": {
        "changeInvoiceDate": "Change invoice date.",
        "moveCost": "Move cost",
        "moveInvoiceDate": "Move invoice date",
        "newInvoiceDate": "New invoice date"
    },
    "moveUsersToNewCompany": {
        "noCompanySelected": "No company selected",
        "movingOfUsersFinished": "Moving of users finished.",
        "youMustChooseACompanyToMoveTo": "You must choose a company to move to",
        "startsMovingOfUsers": "Starts moving of users.",
        "selectUsersToMove": "Select users to move",
        "moveUsersToNewCompany": "Move users to new company",
        "selectAllAccounts": "Select all accounts",
        "companyYouAreMovingFrom": "Company you are moving from",
        "chooseCompanyToMoveTo": "Choose company to move to",
        "newDomain": "New domain",
        "newEmail": "New email"
    },
    "newCompany": {
        "customerCreated": "Customer created.",
        "noCustomerNumber": "No customer number",
        "noOrgNo": "No org. no.",
        "createCustomer": "Create customer",
        "selectACompanyFromSuperOffice": "Select a company from SuperOffice",
        "selectCustomer": "Select customer",
        "noPersonsWithEmail": "No persons with email",
        "selectAdmin": "Select admin",
        "sendEmailToAdmin": "Send email to admin",
        "createCompany": "Create company",
        "createAdmin": "Create admin"
    },
    "newContractContainer": {
        "changedContractInformation": "Changed contract information.",
        "isByggdataContract": "Must select seller on Byggdata contracts.",
        "startingSale": "Starting sale.",
        "contractIsCreated": "Contract is created"
    },
    "addGroup": {
        "newGroupAdded": "New group added.",
        "couldNotAddNewGroup": "Could not add new group."
    },
    "addNewVersion": {
        "newVersionCreated": "New version created.",
        "couldNotCreateNewVersion": "Could not create new version",
        "selectName": "Select name"
    },
    "addProducts": {
        "productAddedToGroup": "Product added to group.",
        "couldNotAddProductToGroup": "Could not add product to group.",
        "contractInfo": "Contract info",
        "nimbusCode": "Nimbus code",
        "nimbusGroupCode": "Nimbus group code",
        "recurringInventoryItemId": "Recurring inventory item ID",
        "setupInventoryItemId": "Setup inventory item ID",
        "setupPrice": "Setup price",
        "startupItemId": "Startup item ID",
        "newLicense": "New license",
        "idForNextItem": "ID for next item",
        "quantityBeforeNextItem": "Quantity before next item"
    },
    "copyLicenseAccess": {
        "licenseYouWantToCopy": "License you want to copy"
    },
    "deleteProductCategtory": {
        "groupDeleted": "Group deleted.",
        "couldNotDeleteGroup": "Could not delete group.",
        "deleteProductCategory": " Delete product category"
    },
    "deleteRelatedProduct": {
        "productDeleted": "Product deleted.",
        "couldNotDeleteProduct": "Could not delete product."
    },
    "deleteVersion": {
        "versionDeleted": "Version deleted.",
        "couldNotDeleteVersion": "Could not delete version."
    },
    "editProduct": {
        "changeDone": "Change done.",
        "failedToExecuteChange": "Could not execute change.",
        "newProductCreated": "New product created.",
        "couldNotCreateNewProduct": "Could not create new product.",
        "example": "Example",
        "mainProduct": "Main product (Only for subproducts)",
        "urlToWebsite": "Url to website (Only for Webapp)",
        "vismaArticleID": "Visma article ID",
        "supportCategory": "User support category",
        "descriptionOfRequirements": "Description of requirements",
        "productDescription": "Product description",
        "linkToProductPage": "Link to product page",
        "notToBeLicensedInNimbus": "Not to be licensed in Nimbus"
    },
    "editVersion": {
        "newFile": "New file",
        "fileUpdated": "File updated",
        "failedToUpdateFile": "Could not update file.",
        "fileDeleted": "File deleted.",
        "couldNotDeleteFile": "Could not delete file.",
        "releaseDate": "Release date",
        "selectTodaysDate": "Select today's date",
        "fileType": "File type",
        "programVersion": "Program version",
        "useAsLastDownload": "Use as last download",
        "updateFile": "Update file",
        "deleteFile": "Delete file"
    },
    "licenseAccessGrid": {
        "mergeInFields": "Merge in fields",
        "userID": "User ID",
        "maintenanceExpiration": "Maintenance expiration",
        "productStructure": "Product structure"
    },
    "groups": {
        "deleteProductGroup": "Delete product group",
        "productCategories": "Product categories",
        editDescription: "Edit description",
        description: "Description",
        changeProductGroupDescription: "Change product group description",
        productCategory: "Product category",
        startupPUK: "Startup PUK",
        renewalPUK: "Renewal PUK",
    },
    "import": {
        "itemHasBeenUpdated": "Item has been updated.",
        "couldNotUpdateItem": "Could not update item.",
        "update": "Update",
        "newItem": "New item",
        "canBeUpdated": "Can be updated",
        "costPrice": "Cost price",
        "itemType": "Item type",
        "interval": "Interval",
        "requiredQuantity": "Req. quantity",
        "userSupportIncluded": "User support included",
        "showItemsWithoutChanges": "Show items without changes"
    },
    "items": {
        "seeContractInfo": "See contract info",
        "nimbusProductCode": "Nimbus product code",
        "setupInventoryItem": "Setup inventory item",
        "supportIncluded": "Support included",
        "licensingInNimbus": "Licensing in Nimbus",
        "canBeSold": "Can be sold",
        "connectedItem": "Connected item"
    },
    "productList": {
        "parentName": "Parent name",
        "interests": "Interests",
        "productCode": "Product code"
    },
    "productStructureGrid": {
        "groups": "Groups",
        "contractItems": "Contract items",
        "itemsImport": "Item import",
        "autodeskImport": "Autodesk import",
        "myPageInterests": "My Page interests"
    },
    "productVersionGrid": {
        "versionName": "Version name",
        "numberOfFiles": "No. of files"
    },
    "deleteContactsError": {
        "errorMessageSetAsHandled": "Error message set as handled.",
        "couldNotSetErrorMessageAsHandled": "Could not set error message as handled.",
        "areYouSureYouWantToSetAsHandled": "Are you sure you want to set as handled?",
        "errorMessageIsSetAsHandledInDatabase": "The error message is set as handled in the database."
    },
    "overview": {
        "failedLogins": "Failed logins",
        "saleLastWeek": "Sale last week",
        "newCompanyRequests": "New company requests",
        "failedOrders": "Failed orders",
        "offlineLicensesRenewal": "Offline licenses renewal",
        "reason": "Reason",
        "startedUsing": "Started using",
        "orderID": "Order ID",
        "daysToRenewal": "Days to renewal",
        "terminates": "Terminates",
        proposals: "Proposals",
    },
    "pageTitle": {
        "noCustomerSelected": "No customer selected..."
    },
    "periodChurnReport": {
        "monthlyValue": "Monthly value",
        "annualValue": "Annual value",
        "retrieveData": " Retrieve data",
        "seatChurn": "Seat churn",
        "seatGrowth": "Seat growth",
        "incomeChurn": "Income churn",
        "incomeGrowth": "Income growth",
        "startSeats": "Seats start",
        "endSeats": "Seats end",
        "startIncome": "Income start",
        "endIncome": "Income end",
        "incomeDiff": "Income difference",
        "seatsDiff": "Seats difference",
        "all": "All"
    },
    "personsInSuperOffice": {
        "haveAccount": "Have account",
        "deletedAccounts": "Deleted accounts",
        "onlyWithoutAccount": "Only without account"
    },
    "productUsageChart": {
        "licenseUsage": "License usage"
    },
    "releaseSession": {
        "loanReleasedItMayTakeSomeTimeForItToAppear": "Loan released. It may take some time for it to appear."
    },
    "newSales": {
        "newSales": "New sales"
    },
    "newSalesGrid": {
        "establishmentItem": "Establishment item",
        "establishmentItemName": "Establishment item name",
        "saleCostPrice": "Cost price sale",
        "saleContributionMargin": "DB sale",
        "recurringCostPrice": "Cost price recurring",
        "recurringContributionMargin": "ACV",
        "differentInVisma": "Different in Visma"
    },
    "renewalsGrid": {
        "timesInvoicedInPeriod": "No. of invoicing in period",
        "activeNextInvoice": "Will be renewed"
    },
    "searchBar": {
        "somethingWentWrong": "Something went wrong",
        "working": "Working...",
        "retrievingFocusAccounts": "Retrieving Focus accounts...",
        "findCompanyForFocusAccount": "Find company for Focus account",
        "createCustomer": "Create customer"
    },
    "secretPage": {
        "selectPage": "Select page"
    },
    "sessionDetails": {
        "details": "Details",
        "licenseType": "License type",
        "loggedInToMyPage": "Logged in to My Page",
        "loginTimeInSeconds": "Log in time in seconds",
        "containerProduct": "Container product",
        "containerVersion": "Container version",
        "processID": "Process ID",
        "windowsUser": "Windows user"
    },
    "signalRContext": {
        "failedToConnectToSignalR": "Could not connect to SignalR",
        "actionExecuted": "Action executed",
        "step": "Step",
        "infoFetched": "Info fetched",
        "orderValidated": "Order validated",
        "userRightsValidated": "User rights validated"
    },
    "supportReport": {
        "startingBalance": "Starting balance",
        "production": "Production",
        "finalBalance": "Final balance",
        "income": "Income",
        "showNoChanges": "Show companies without changes",
    },
    "webUpdates": {
        "webUpdates": "Web updates",
        "seconds": "Seconds",
        "files": "Files",
        "size": "Size"
    },
    "usersWithoutCompany": {
        "country": "Country"
    },
    "validateEmail": {
        "askUserToCreatePasswordFromMyPage": "Ask user to create password from My Page",
        "createAccountOnUser": "Create account on user.",
        "noActionRequired": "No action required.",
        "userHasBeenSentAnInvitationByEmailEtc": "User has been sent an invitation by email and must approve it. Alternatively, they can choose 'forgot password' on My Page.",
        "administratorInCompanyMustApproveAccountRequestEtc": "Administrator in the company must approve account request. If user logs in on My Page, they can send a new request to administrator.",
        "askUserToLoginToMyPageAndCompleteRegistration": "Ask user to log in to My Page and complete registration.",
        "checkFocusAccount": "Check Focus account",
        "emailYouWantToCheckFocusAccountStatusOn": "Email you want to check Focus account status on.",
        "checkFocusAccountStatus": "Check Focus account status",
        "focusAccountStatus": "Focus account status",
        "statusOnFocusAccount": "Status on Focus account",
        "actionRequired": "Action required",
        "userSupportStatus": "Status on user support",
        "other": "Other",
        "userHasLoggedInToMyPage": "User has logged in to My Page.",
        "accountBlockedInWebKua": "Account blocked in WebKua.",
        "personRetiredInWebKua": "Person retired in WebKua",
        "accountChanges": "Account changes",
        "performedBy": "Performed by"
    },
    "webkuaChart": {
        "showGraphAsLine": "Show graph as line",
        "selectProductsTimePeriodEtcAndRefreshTableToRetrieveData": "Select products, time period, etc., and refresh the table to retrieve data.",
        "selectDatasetToDisplayGraph": "Select dataset to display graph.",
        "thereIsNoDataToDisplayForSelectedPeriod": "There is no data to display for the selected period.",
        ifYouHaveMadeChangesToSearchCriteriaEtc: "If you have made changes to the search criteria, remember to press the 'Refresh' button to retrieve new data.",
        emptyProductListCompanySelectionSelectsAllProductsCompanies: "Empty product list/company selection selects all products/companies.",
        noDataInTheSearch: "No data in the search.",
    },
    "webkuaTable": {
        "exportToExcel": "Export to Excel",
        "noVisibleExportColumns": "Show at least one exportable column before exporting to Excel."
    },
    "helpers": {
        "noDate": "No date",
        "valueMissing": "Value missing",
        "noAccountOnEmail": "No account on email",
        "noKnownIssues": "No known issues",
        "invitationExists": "Invitation exists",
        "accountRequestExists": "Account request exists",
        "userHasNotFinishedRegistration": "User has not finished registration"
    },
    "requestUtils": {
        "configurationSaved": "Configuration saved",
        "configurationReset": "Configuration reset"
    },
    "baseCourse": {
        "updatedCcourseInList": "Updated course in list.",
        "couldNotUpdateCourseInList": "Could not update course in list.",
        "updatedCourseInListAndSentAnEmailToContactPerson": "Updated course in list and sent an email to the contact person.",
        "unknownCourse": "Unknown course.",
        "linkToCourse": "Link to course",
        "cancelCourse": "Cancel course",
        "doNotPublishCourse": "Do not publish course",
        "goToCourse": "Gå til kurset",
        "registrant": "Registrant",
        "courseConfirmationEmailTemplate": "Course confirmation email template",
        "template": "Mal",
        "sendConfirmation": "Send confirmation",
        "preamble": "Ingress",
        "superOfficeComments": "SuperOffice comments",
        "duplicate": "Duplicate",
        "day": "day"
    },
    "standard": {
        "payerCode": "Payer Code",
        "contractNumber": "Contract number",
        "gettingData": "Getting data...",
        "lastUsed": "Last used",
        "reason": "Reason",
        "email": "Email",
        "phone": "Phone",
        "organisationNumber": "Org. no.",
        "decline": "Decline",
        "cancel": "Cancel",
        "remove": "Remove",
        "open": "Open",
        "company": "Company",
        "processRequest": "Process request",
        "companyName": "Company name",
        "adminFirstName": "Admin first name",
        "adminLastName": "Admin last name",
        "date": "Date",
        "contracts": "Contracts",
        "companyNo": "Company no.",
        "contractNo": "Contract no.",
        "contractType": "Contract type",
        "startDate": "Start date",
        "nextInvoiceDate": "Next invoice date",
        "nextInvoiceCost": "Next invoice cost",
        "academicVersion": "Academic version",
        "note": "Note",
        "group": "Group",
        "productName": "Product name",
        "recurringItem": "Recurring item",
        "type": "Type",
        "invoiceInterval": "Contract duration",
        "seats": "Seats",
        "oneTimeDiscount": "One-time discount (%)",
        "recurringDiscount": "Recurring discount (%)",
        "discount": "Discount",
        "client": "Client",
        "residualValue": "Residual value",
        "recidualValueAtYearStart": "Residual value at the start of the new year",
        "month": "Month",
        "year": "Year",
        "nextInvoicingDate": "Next invoicing date",
        "newSale": "New sale",
        "licenseNumber": "License no.",
        "name": "Name",
        "expirationDate": "Maintenance end",
        "terminationDate": "End date",
        "discountPercent": "Discount (%)",
        "companyNumber": "Customer no.",
        "customerName": "Customer name",
        "showOnlyTerminationDate": "Show only for end date",
        "activationDate": "Activation date",
        "orderDate": "Bestillingsdato",
        "orderType": "Order type",
        "errorText": "Error message",
        "changedBy": "Changed by",
        "activeOrder": "Active order",
        "deleted": "Deleted",
        "requestDate": "Request date",
        "inNimbus": "In Nimbus",
        "inSuperoffice": "In SuperOffice",
        "blockedInNimbus": "Blocked in Nimbus",
        "blockedInCosmos": "Blocked in Cosmos",
        "duplicated": "Duplicated",
        "delete": "Delete",
        "change": "Change",
        "parentLicenseNumber": "Parent license no.",
        "product": "Product",
        "nextInvoice": "Next invoice date",
        "courseName": "Course name",
        "selectProducts": "Select products",
        "evaluation": "Evaluation",
        "noEvaluation": "No evaluation",
        "addNewEvaluationForm": "Add new evaluation form",
        "doNotPublish": "Do not publish",
        "description": "Description",
        "selectPrice": "Select price",
        "address": "Address",
        "firstName": "First name",
        "lastName": "Last name",
        "activated": "Activated",
        "createdBy": "Created by",
        "back": "Back",
        "next": "Next",
        "quantity": "Quantity",
        "price": "Price",
        "executionDate": "Execution date",
        "account": "Account",
        "copies": "Copies",
        "newCourse": "New course",
        "duration": "Duration",
        "copy": "Copy",
        "addCourse": "Add course",
        "areYouSureYouWantToDeleteCourse": "Are you sure you want to delete the course?",
        "updateCourse": "Update course",
        "changeCourse": "Change course",
        "conflicts": "Conflicts",
        "cancelled": "Cancelled",
        "trainingRoom": "Training room",
        "place": "Place",
        "adskCourseId": "ADSK course ID",
        "instructor": "Instructor",
        "assistantInstructor": "Assistant instructor",
        "linkToCourse": "Link to course",
        "maxNumberOfSeats": "Max number of seats",
        "postCode": "Postcode",
        "selectComputerEquipment": "Select computer equipment",
        "courseWithTotalPrice": "Course with total price",
        "priceInformation": "Price information",
        "additionalInformationForParticipantUponConfirmationOfRegistration": "Additional information for participant upon confirmation of registration",
        "courseList": "Course list",
        "save": "Save",
        "complete": "Complete",
        "code": "Code",
        "confirmationCourseRegistration": "Confirmation of course registration",
        "reset": " Reset",
        "cancelingCourse": "Canceling course",
        "movingCourses": "Moving courses",
        "updatedText": "Updated text.",
        "couldNotUpdateText": "Could not update text.",
        "contactPersonForInvoice": "Contact person for invoice",
        "mobileNo": "Mobile no.",
        "invoiceEmail": "Invoice email",
        "orderReference": "PO no./invoice reference",
        "employeeNumber": "Employee no.",
        "otherComments": "Other comments",
        "move": "Move",
        "reactivate": "Reactivate",
        "lastChanged": "Last changed",
        "courseParticipant": "Course participant",
        "from": "From",
        "to": "To",
        "level": "Level",
        "comments": "Comments",
        "newCategory": "New category",
        "category": "Category",
        "selectFromSuperOffice": "Select from SuperOffice",
        "newDuration": "New duration",
        "addedInstructorToList": "Added instructor to list.",
        "newInstructor": "New instructor",
        "adskInstructorId": "ADSK instructor ID",
        "city": "City",
        "newLevel": "New level",
        "addedLocationToList": "Added location to list.",
        "newPlace": "New place",
        "show": "Show",
        "newPrice": "New price",
        "computerEquipment": "Computer equipment",
        "prices": "Prices",
        "pictures": "Pictures",
        "course": "Course",
        "numberOfDays": "Number of days",
        "emails": "Emails",
        "newEmail": "New email",
        "emailSubject": "Email subject",
        "currency": "Currency",
        "userSupport": "User support",
        "academic": "Academic",
        "customerNumber": "Customer number",
        "contractManager": "Contract manager",
        "retrievingData": "Retrieving data",
        "addCompanyDepartment": "Add company / department",
        "changesFocusAccount": "Changes Focus account.",
        "couldNotChangeFocusAccount": "Could not change Focus account.",
        "importTicket": "Import case",
        "getTicket": "Get case",
        "title": "Title",
        "changeUsers": "Change users",
        "employee": "Employee",
        "module": "Module",
        "item": "Item",
        "changes": "Changes",
        "expired": "Expired",
        "activeOnly": "Only active",
        "active": "Active",
        "licenses": "Licenses",
        "invoiceCost": "Invoice cost",
        "newContract": "New contract",
        "orderOverview": "Order overview",
        "moveContracts": "Move contracts",
        "mergeContracts": "Merge contracts",
        "showForGroup": "Show for group",
        "domainAccess": "Domain access",
        "access": "Access",
        "licensingCoordinator": "Licensing coordinator",
        "assignLicenseRights": "Assign license rights",
        "assignDemoLicenseRights": "Assign demo license rights",
        "giveEveryoneLicenseAccess": "Give everyone license access",
        "makeEveryoneACoordinator": "Make everyone a coordinator",
        "removeAllLicenseAccess": "Remove all license access",
        "removeAllCoordinators": "Remove all coordinators",
        "action": "Action",
        "sendEmail": "Send email",
        "customerDetails": "Customer details",
        "contract": "Contract",
        "terminated": "Terminated",
        "focusAccount": "Focus account",
        "student": "Student",
        "credit": "Credit",
        "amount": "Amount",
        "createsCustomer": "Creates customer",
        "role": "Role",
        "accesses": "Accesses",
        "coordinator": "Coordinator",
        "created": "Created",
        "productList": "Product list",
        "modules": "Modules",
        "offline": "Offline",
        "variant": "Variant",
        "version": "Version",
        "numberOfSeats": "No. of seats",
        "loan": "Loan",
        "automaticLicenseApproval": "Automatic license approval",
        "copyLicenseRights": "Copy license rights",
        "externalLicenseRights": "External license rights",
        "username": "Username",
        "external": "External",
        "license": "License",
        "person": "Person",
        "loanId": "Loan ID",
        "returned": "Returned",
        "borrowed": "Borrowed",
        "newLicensingSystem": "New licensing system",
        "user": "User",
        "domain": "Domain",
        "machine": "Machine",
        "changeEmail": "Change email",
        "blocked": "Blocked",
        "retired": "Retired",
        "changesLicenseAccesses": "Changes license accesses.",
        "language": "Language",
        "selectAdministrator": "Select administrator",
        "components": "Components",
        "add": "Add",
        "selectTriggerType": "Select trigger type",
        "days": "days",
        "triggerDescription": "Trigger description",
        "variables": "variables",
        "changeLicense": "Change license",
        "recurringDiscountPercent": "Recurring discount (%)",
        "renewalPrice": "Renewal price",
        "productCode": "Product code",
        "timestamp": "Timestamp",
        "errorType": "Error type",
        "function": "Function",
        "backupRetrieved": "Backup retrieved",
        "noBackupFound": "No backup found",
        "shortDescription": "Short description",
        "saveAsBackup": "Save as backup",
        "sendingYouTo": "Sending you to",
        "working": "Working",
        "activeUsers": "Active users",
        "freeUpLoans": "Free up loans",
        "licenseModel": "License model",
        "expiryDate": "Expiry date",
        "loanStart": "Loan start",
        "accountID": "Account ID",
        "department": "Department",
        "companyID": "Company ID",
        "number": "Number",
        "school": "School",
        "processes": "Processes",
        "mainProduct": "Main product",
        "mainLicenseNo": "Main license no.",
        "productVersion": "Product version",
        "fileVersion": "File version",
        "seat": "Seat",
        "maxSeat": "Max seat",
        "fileName": "File name",
        "sessionID": "Session ID",
        "started": "Started",
        "stopped": "Stopped",
        "loanID": "Loan ID",
        "expires": "Expires",
        "lastRenewed": "Last renewed",
        "returnType": "Return type",
        "releasedBy": "Released by",
        "volumeID": "Volume ID",
        "operatingSystem": "Operating system",
        "macAddresses": "MAC addresses",
        "virtualMachine": "Virtual machine",
        "personID": "Person ID",
        "expiredLicenses": "Expired licenses",
        "loginFailed": "Login failed",
        "licenseExploitation": "License exploitation",
        "logons": "Logons",
        "hoursLoggedOn": "Hours logged on",
        "hoursPerSeat": "Hours/Seat",
        "offlineLicenses": "Offline licenses",
        "personActivity": "Person activity",
        "rejectedLogin": "Rejected login",
        "products": "Products",
        "myPageStatus": "My Page status",
        "period": "Period",
        "terminatedItems": "Terminated items",
        "newItems": "New items",
        "changedItems": "Changed items",
        "activeItems": "Active items",
        "errorItems": "Error items",
        "licenseName": "License name",
        "addProductGroup": "Add product group",
        "groupName": "Group name",
        "newVersion": "New version",
        "addProduct": "Add product",
        "recurringPrice": "Recurring price",
        "seatsPerQuantity": "Seats per license",
        "cloudLicensing": "Cloud licensing",
        "canSell": "Can sell",
        "additionalProduct": "Additional product",
        "areYouSureYouWantToDelete": "Are you sure you want to delete?",
        "productCategory": "Product category",
        "deleteProduct": "Delete product",
        "deleteVersion": "Delete version",
        "changeProduct": "Change product",
        "systemRelatedProducts": "System related products",
        "changeVersion": "Change version",
        "nimbusCode": "Nimbus code",
        "uploadExcelFile": "Upload Excel file",
        "submodules": "Submodules",
        "selectProduct": "Select product",
        "setAsHandled": "Set as handled",
        "overview": "Overview",
        "companyChurn": "Company churn",
        "companyGrowth": "Company growth",
        "create": "Create",
        "report": "Report",
        "seller": "Seller",
        "invoiceDate": "Invoice date",
        "productGroup": "Product group",
        "renewals": "Renewals",
        "costPrice": "Cost price",
        "netGain": "DB",
        "sales": "Sales",
        "notReleased": "Not released",
        "noAccountSelected": "No account selected",
        "licenseAccess": "License access",
        extendTrial: "Extend trial",
        stopTrial: "Stop trial",
        thereAreNoLicensesToDisplayHere: "There are no licenses to display here.",
        details: "Details",
        hiddenChanges: "Hidden changes",
        newLicense: "New license",
        viewExpiredLicenses: "View expired licenses",
        maintenance: "Maintenance",
        unitCost: "Unit cost",
        totalPrice: "Total price",
        paymentOverview: "Payment overview",
        renewalDate: "Renewal date",
        moveInvoiceDate: "Move invoice date",
        totalBeforeDiscount: "Total before discount",
        totalInvoiceAmount: "Total invoice amount",
        goToApproval: "Go to approval",
        start: "Start",
        contractInformation: "Contract information",
        sellerInSuperOffice: "Seller in SuperOffice",
        overrideSeller: "Override seller",
        useSellerInSuperOffice: "Use seller in SuperOffice",
        missingAccount: "Missing account",
        hide: "Hide",
        comment: "Comment",
        sum: "Sum",
        invoiceInformation: "Invoice information",
        missingInSuperOffice: "Missing in SuperOffice",
        customersOrderNumber: "Customer's order number",
        invoiceResponsible: "Invoice responsible",
        updateContract: "Update contract",
        trialLicenses: "Trial licenses",
        nonAcademic: "Non-academic",
        unpackSeats: "Unpack seats",
        includeRestructuring: "Include restructuring",
        new: "New",
        activatedOnMyPage: "Activated on MyPage",
        accounts: "Accounts",
        admin: "Admin.",
        allCompanies: "All companies",
        newCompanies: "New companies",
        productID: "Product ID",
        numberOfUsers: "Number of users",
        companyGroupID: "Company group ID",
        monthlyValueOfLicenses: "Monthly value of licenses",
        yearlyValueOfLicenses: "Yearly value of licenses",
        status: "Status",
        reports: "Reports",
        invoiceAmount: "Invoice amount",
        added: "Added",
        licenseType: "License type",
        showM2S: "Show M2S",
        salePrice: "Sale price",
        createNewPeopleInSuperOffice: "Create new people in SuperOffice",
        answer: "Answer",
        waitingForResponse: "Waiting for response",
        approvedOffers: "Approved offers",
        expiredOffers: "Expired offers",
        offer: "Offer",
        newOffer: "New offer",
        sent: "Sent",
        deadline: "Deadline",
        lastContact: "Last contact",
        state: "State",
        offerNo: "Offer no.",
        createNewOffer: "Create new offer",
        deleteOffer: "Delete offer",
        salesAmount: "Sales amount",
        dateOfMove: "Date of move",
        none: "None",
        noPriceInformation: "No price information",
        noTimeSpent: "No time spent",
        domainsThatAutomaticallyApproveAccounts: "Domains that automatically approve accounts",
        setDiscountOnAll: "Set discount on all",
        internalNote: "Internal note",
        validUntil: "Valid until",
        ourProposal: "Our proposal",
        customer: "Customer",
        recipientOfOffer: "Recipient of offer",
        noteToCustomer: "Note to customer",
        customerProposal: "Customer proposal",
        close: "Close",
        licenseNr: "License no.",
        customerNo: "Customer no.",
        reasonForSale: "Reason for sale",
        addDescription: "Add a description",
        twoFactorEnabled: "Two-factor enabled",
        pleaseEnterValidEmailAddress: "Please enter a valid email address",
        lastNameRequired: "Last name is required",
        firstNameRequired: "First name is required",
        createFocusAccount: "Create Focus account",
    },
    "simpleTable": {
        "searchInTable": "Search in table",
        "last24Hours": "Last 24 hours",
        "nextYear": "Next year",
        "nextMonth": "Next month",
        "nextWeek": "Next week",
        "today": "Today",
        "lastWeek": "Last week",
        "lastMonth": "Last month",
        "lastYear": "Last year",
        "custom": "Custom",
        "selectAll": "Select all",
        "selectAllPossible": "Select all possible ({{maxCount}})",
        "copy": "Copy",
        "export": "Export",
        "date": "Date",
        "from": "From",
        "to": "To",
        "show": "Show",
        "search": "Search",
        "showQuantity": "Show quantity",
        "total": "Total",
        "saveTableConfiguration": "Save table configuration",
        "resetTableConfiguration": "Reset table configuration",
        seller: "Seller",
    },
    reasonsForSale: {
        Other: "Other",
        Restructuring: "Not counted in churn",
        Bankruptcy: "Bankruptcy",
        Retired: "Retired",
        NoNeedForProduct: "No need for product",
        ChangedToCompetitor: "Have purchased a competing product",
        SaveMoney: "Stopped to save money"
    },
    "froala": {
        "addTextOrImages": "Add text or images here"
    },
    contract: {
        change: "Change",
    },
    "shop": {
        "webshop": "Webshop",
        "offer": "Offer",
        "selectProduct": "Select product",
        "selectQuantity": "Select quantity",
        "register": "Register",
        "confirmation": "Confirmation",
        "currentContract": "Current contract",
        "contractNumber": "Contract no.",
        "contractDetails": "Contract details",
        "currentSeats": "Current seats",
        "productName": "Product name",
        "renewalDate": "Renewal date",
        "action": "Action",
        "add": "Add",
        "searchInProducts": "Search in products",
        "perYear": "per year",
        "productPage": "Product page",
        "addNewOrExisting": "Add product seats or licenses",
        "moduleNames": "Modules",
        "requires": "Requires",
        "addSeats": "Add seats",
        "addLicense": "Add license",
        "newLicense": "New license",
        "addNewLicense": "Add new license",
        "newContract": "New contract",
        "addNewContract": "Add new contract",
        "licenseNumber": "License no.",
        "cart": "Cart",
        "freeSeatAlteration": "Free seat alteration",
        "duration": "Duration",
        "months": "months",
        "type": "Type",
        "sumSubscription": "Sum subscription",
        "sumUntilRenewal": "Sum until renewal",
        "pricePerSeat": "Standard price",
        "buyMoreMsg": "Any additional products will be added to this contract. Finish the purchase or cancel to select a different contract.",
        "priceNowMsg": "Total price for renewal",
        recurringTotalPrice: "Recurring total price",
        "sumInvoiced": "Sum invoiced",
        "invoiceInterval": "Invoice interval (months)",
        "invoiceIntervalInfoText": "Can only add products to contracts with invoice interval of 12 months",
        "priceNow": "Billed now",
        "orderNum": "Order no.",
        "yourOrderNumTooltip": "Use the order number to send the invoice to designated individuals in your company.",
        "buyMore": "Buy more",
        "goToConfirmation": "Go to confirmation",
        "acceptCounterProposal": "Accept counter proposal",
        "createProposal": "Create proposal",
        "saveOffer": "Save offer",
        "subscriptionPrice": "Sub. price",
        "iAcceptAll": "I accept all",
        "terms": "terms",
        "orderCompleted": "Order completed",
        "thankYouForPurchase": "Thank you for your purchase",
        "orderCompleted2": "Order Id {{orderId}} is completed and will be available for immediate use. Remember to distribute license access to the users.",
        "productOverview": "Product overview",
        "noItemsInCart": "You have no items in your shopping cart",
        "addProductFirst": "Add a product first",
        "backToWebshop": "Back to webhop",
        "contractResponsible": "Contract responsible",
        "newLicenseMsg": "Here you create a new contract with a new license. Start from today's date.",
        "addSeatsMsg": "Here you can add seats to existing licenses.",
        "addLicenseMsg": "Here you can add new licenses to existing contracts that do not already include this program.",
        "numberOfProducts": "Number of products",
        "confirmOfferTitle": "Confirm offer",
        "confirmOfferText": "Are you sure you want to confirm the offer?",
        "confirmOfferTextDraft": "This will send the offer to the customer.",
        "confirmOfferTextPending": "This will overwrite the existing offer to the customer",
        "confirmOfferTextCounterProposal": "This will remove the customers counter offer and overwrite the existing offer to the customer",
        "confirmOfferTextAccepted": "The offer has already been accepted by the customer. This will reopen the offer.",
        "confirmOfferTextRejected": "The offer has already been rejected by the customer. This will reopen the offer.",
        "confirmOfferTextExpired": "The offer has expired. This will reopen the offer.",
        "offerHasErrorText": "The recurring discounts contain potential errors. Only an admin can submit the offer in its current state.",
        "offerHasErrorText2": "Autodesk products should have recurring discount =25% only for autodesk customers. Otherwise all products should have recurring discount = 0%.",
        "sendOffer": "Send offer",
        "cartOverview": "Cart overview",
        "offerSaved": "Offer saved",
        "sendingOffer": "Sending offer",
        "acceptingCounterProposal": "Accepting counter proposal",
        "proposalDeleted": "Proposal deleted",
        "offerSent": "Offer sent",
        "offerAccepted": "Offer accepted",
        "noProposalRecepientsError": "No proposal recipients, please add one or more",
        "noProductsError": "No products in the cart",
        oneTimeDiscountTotal: "One-time discount total",
        recurringDiscountTotal: "Recurring discount total",

    },
    "licenseType": {
        "slm": "Single user",
        "nlm": "Multi user",
        "namedUser": "Named user",
        "oneTime": "One time product",
        "unknown": "Unknown"
    },
    "proposalState": {
        "Accepted": "Accepted",
        "Pending": "Pending (Waiting on customer)",
        "Draft": "Draft",
        "CounterProposal": "Counter proposal (Waiting on seller)",
        "Rejected": "Rejected",
        "Expired": "Expired",
        "Active": "Active",
    },

}